import { __values, __extends } from 'tslib';
import { InjectionToken, Injectable, Inject, ɵɵdefineInjectable, ɵɵinject, Component, Input, EventEmitter, NgZone, Output, ElementRef, ViewChild, HostBinding, ViewChildren, NgModule } from '@angular/core';
import { HttpHeaders, HttpParams, HttpClient, HttpClientModule } from '@angular/common/http';
import { Subject, BehaviorSubject } from 'rxjs';
import { map, debounceTime, takeWhile, take } from 'rxjs/operators';
import { Location as Location$1, DOCUMENT, CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { parse, stringify } from 'querystring';
import { CookieService } from 'ngx-cookie-service';
import { FormsModule } from '@angular/forms';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { DialogService as DialogService$1 } from 'projects/wfbhsearch/src/lib/dialog.service';
import { Options } from 'ngx-google-places-autocomplete/objects/options/options';
import { ActiveDescendantKeyManager, A11yModule } from '@angular/cdk/a11y';
import { ENTER, UP_ARROW, DOWN_ARROW, TAB } from '@angular/cdk/keycodes';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Location = /** @class */ (function () {
    function Location(address1, address2, floorsuite, name, phone, pageurl, distance) {
        this.address1 = address1;
        this.address2 = address2;
        this.floorsuite = floorsuite;
        this.name = name;
        this.phone = phone;
        this.pageurl = pageurl;
        this.distance = distance;
    }
    return Location;
}());
if (false) {
    /** @type {?} */
    Location.prototype.address1;
    /** @type {?} */
    Location.prototype.address2;
    /** @type {?} */
    Location.prototype.floorsuite;
    /** @type {?} */
    Location.prototype.name;
    /** @type {?} */
    Location.prototype.phone;
    /** @type {?} */
    Location.prototype.pageurl;
    /** @type {?} */
    Location.prototype.distance;
}
var SearchResult = /** @class */ (function () {
    function SearchResult(permanentId, cmsUri, title, uri, position, specialist, specialties, providerType, languages, image, newpatients, existingpatients, firstname, lastname, gender, onlineSchedule, directSchedule, visitType, epicId, messagePath, fullName, author, rating, totalRatings, showRating, locations) {
        if (showRating === void 0) { showRating = false; }
        if (locations === void 0) { locations = []; }
        this.permanentId = permanentId;
        this.cmsUri = cmsUri;
        this.title = title;
        this.uri = uri;
        this.position = position;
        this.specialist = specialist;
        this.specialties = specialties;
        this.providerType = providerType;
        this.languages = languages;
        this.image = image;
        this.newpatients = newpatients;
        this.existingpatients = existingpatients;
        this.firstname = firstname;
        this.lastname = lastname;
        this.gender = gender;
        this.onlineSchedule = onlineSchedule;
        this.directSchedule = directSchedule;
        this.visitType = visitType;
        this.epicId = epicId;
        this.messagePath = messagePath;
        this.fullName = fullName;
        this.author = author;
        this.rating = rating;
        this.totalRatings = totalRatings;
        this.showRating = showRating;
        this.locations = locations;
    }
    return SearchResult;
}());
if (false) {
    /** @type {?} */
    SearchResult.prototype.permanentId;
    /** @type {?} */
    SearchResult.prototype.cmsUri;
    /** @type {?} */
    SearchResult.prototype.title;
    /** @type {?} */
    SearchResult.prototype.uri;
    /** @type {?} */
    SearchResult.prototype.position;
    /** @type {?} */
    SearchResult.prototype.specialist;
    /** @type {?} */
    SearchResult.prototype.specialties;
    /** @type {?} */
    SearchResult.prototype.providerType;
    /** @type {?} */
    SearchResult.prototype.languages;
    /** @type {?} */
    SearchResult.prototype.image;
    /** @type {?} */
    SearchResult.prototype.newpatients;
    /** @type {?} */
    SearchResult.prototype.existingpatients;
    /** @type {?} */
    SearchResult.prototype.firstname;
    /** @type {?} */
    SearchResult.prototype.lastname;
    /** @type {?} */
    SearchResult.prototype.gender;
    /** @type {?} */
    SearchResult.prototype.onlineSchedule;
    /** @type {?} */
    SearchResult.prototype.directSchedule;
    /** @type {?} */
    SearchResult.prototype.visitType;
    /** @type {?} */
    SearchResult.prototype.epicId;
    /** @type {?} */
    SearchResult.prototype.messagePath;
    /** @type {?} */
    SearchResult.prototype.fullName;
    /** @type {?} */
    SearchResult.prototype.author;
    /** @type {?} */
    SearchResult.prototype.rating;
    /** @type {?} */
    SearchResult.prototype.totalRatings;
    /** @type {?} */
    SearchResult.prototype.showRating;
    /** @type {?} */
    SearchResult.prototype.locations;
}
var SearchResults = /** @class */ (function () {
    function SearchResults(results, total, totalFiltered) {
        this.results = results;
        this.total = total;
        this.totalFiltered = totalFiltered;
    }
    return SearchResults;
}());
if (false) {
    /** @type {?} */
    SearchResults.prototype.results;
    /** @type {?} */
    SearchResults.prototype.total;
    /** @type {?} */
    SearchResults.prototype.totalFiltered;
}
var Suggestion = /** @class */ (function () {
    function Suggestion(title, value, suggestType, suggestValue, type, numberOfResults) {
        this.title = title;
        this.value = value;
        this.suggestType = suggestType;
        this.suggestValue = suggestValue;
        this.type = type;
        this.numberOfResults = numberOfResults;
    }
    return Suggestion;
}());
if (false) {
    /** @type {?} */
    Suggestion.prototype.title;
    /** @type {?} */
    Suggestion.prototype.value;
    /** @type {?} */
    Suggestion.prototype.suggestType;
    /** @type {?} */
    Suggestion.prototype.suggestValue;
    /** @type {?} */
    Suggestion.prototype.type;
    /** @type {?} */
    Suggestion.prototype.numberOfResults;
}
var CoveoResult = /** @class */ (function () {
    function CoveoResult(title, clickUri, raw) {
        this.title = title;
        this.clickUri = clickUri;
        this.raw = raw;
    }
    return CoveoResult;
}());
if (false) {
    /** @type {?} */
    CoveoResult.prototype.title;
    /** @type {?} */
    CoveoResult.prototype.clickUri;
    /** @type {?} */
    CoveoResult.prototype.raw;
}
var CoveoResultRaw = /** @class */ (function () {
    function CoveoResultRaw(wfsnavtitle, urllink, wfspositiontitle, wfsisspecialist, wfsspecialties, wfsprovidertype, wfslanguagespoken, wfspersonimage, wfslocationname, wfsacceptingnewpatients, wfsfirstname, wfslastname, wfsgender, wfslocationaddress1, wfslocationaddress2, wfslocationnewpatientslocalphone) {
        this.wfsnavtitle = wfsnavtitle;
        this.urllink = urllink;
        this.wfspositiontitle = wfspositiontitle;
        this.wfsisspecialist = wfsisspecialist;
        this.wfsspecialties = wfsspecialties;
        this.wfsprovidertype = wfsprovidertype;
        this.wfslanguagespoken = wfslanguagespoken;
        this.wfspersonimage = wfspersonimage;
        this.wfslocationname = wfslocationname;
        this.wfsacceptingnewpatients = wfsacceptingnewpatients;
        this.wfsfirstname = wfsfirstname;
        this.wfslastname = wfslastname;
        this.wfsgender = wfsgender;
        this.wfslocationaddress1 = wfslocationaddress1;
        this.wfslocationaddress2 = wfslocationaddress2;
        this.wfslocationnewpatientslocalphone = wfslocationnewpatientslocalphone;
    }
    return CoveoResultRaw;
}());
if (false) {
    /** @type {?} */
    CoveoResultRaw.prototype.wfsnavtitle;
    /** @type {?} */
    CoveoResultRaw.prototype.urllink;
    /** @type {?} */
    CoveoResultRaw.prototype.wfspositiontitle;
    /** @type {?} */
    CoveoResultRaw.prototype.wfsisspecialist;
    /** @type {?} */
    CoveoResultRaw.prototype.wfsspecialties;
    /** @type {?} */
    CoveoResultRaw.prototype.wfsprovidertype;
    /** @type {?} */
    CoveoResultRaw.prototype.wfslanguagespoken;
    /** @type {?} */
    CoveoResultRaw.prototype.wfspersonimage;
    /** @type {?} */
    CoveoResultRaw.prototype.wfslocationname;
    /** @type {?} */
    CoveoResultRaw.prototype.wfsacceptingnewpatients;
    /** @type {?} */
    CoveoResultRaw.prototype.wfsfirstname;
    /** @type {?} */
    CoveoResultRaw.prototype.wfslastname;
    /** @type {?} */
    CoveoResultRaw.prototype.wfsgender;
    /** @type {?} */
    CoveoResultRaw.prototype.wfslocationaddress1;
    /** @type {?} */
    CoveoResultRaw.prototype.wfslocationaddress2;
    /** @type {?} */
    CoveoResultRaw.prototype.wfslocationnewpatientslocalphone;
}
var CoveoFieldSuggestionResult = /** @class */ (function () {
    function CoveoFieldSuggestionResult(lookupValue, numberOfResults, value) {
        this.lookupValue = lookupValue;
        this.numberOfResults = numberOfResults;
        this.value = value;
    }
    return CoveoFieldSuggestionResult;
}());
if (false) {
    /** @type {?} */
    CoveoFieldSuggestionResult.prototype.lookupValue;
    /** @type {?} */
    CoveoFieldSuggestionResult.prototype.numberOfResults;
    /** @type {?} */
    CoveoFieldSuggestionResult.prototype.value;
}
var CoveoFieldSuggestionBatchResult = /** @class */ (function () {
    function CoveoFieldSuggestionBatchResult(batch) {
        this.batch = batch;
    }
    return CoveoFieldSuggestionBatchResult;
}());
if (false) {
    /** @type {?} */
    CoveoFieldSuggestionBatchResult.prototype.batch;
}
var Facet = /** @class */ (function () {
    function Facet(field, selectedValues) {
        if (selectedValues === void 0) { selectedValues = new Set(); }
        this.field = field;
        this.selectedValues = selectedValues;
    }
    return Facet;
}());
if (false) {
    /** @type {?} */
    Facet.prototype.field;
    /** @type {?} */
    Facet.prototype.selectedValues;
}
var FacetOption = /** @class */ (function () {
    function FacetOption(field, title, maximumNumberOfValues, currentOptions, synonymFields, isBool) {
        if (currentOptions === void 0) { currentOptions = []; }
        if (synonymFields === void 0) { synonymFields = []; }
        if (isBool === void 0) { isBool = false; }
        this.field = field;
        this.title = title;
        this.maximumNumberOfValues = maximumNumberOfValues;
        this.currentOptions = currentOptions;
        this.synonymFields = synonymFields;
        this.isBool = isBool;
    }
    return FacetOption;
}());
if (false) {
    /** @type {?} */
    FacetOption.prototype.field;
    /** @type {?} */
    FacetOption.prototype.title;
    /** @type {?} */
    FacetOption.prototype.maximumNumberOfValues;
    /** @type {?} */
    FacetOption.prototype.currentOptions;
    /** @type {?} */
    FacetOption.prototype.synonymFields;
    /** @type {?} */
    FacetOption.prototype.isBool;
}
var FacetOptionValue = /** @class */ (function () {
    function FacetOptionValue(value, lookupValue, numberOfResults, score, valueType) {
        this.value = value;
        this.lookupValue = lookupValue;
        this.numberOfResults = numberOfResults;
        this.score = score;
        this.valueType = valueType;
    }
    return FacetOptionValue;
}());
if (false) {
    /** @type {?} */
    FacetOptionValue.prototype.value;
    /** @type {?} */
    FacetOptionValue.prototype.lookupValue;
    /** @type {?} */
    FacetOptionValue.prototype.numberOfResults;
    /** @type {?} */
    FacetOptionValue.prototype.score;
    /** @type {?} */
    FacetOptionValue.prototype.valueType;
}
var CoveoGroupByResult = /** @class */ (function () {
    function CoveoGroupByResult(field, values) {
        this.field = field;
        this.values = values;
    }
    return CoveoGroupByResult;
}());
if (false) {
    /** @type {?} */
    CoveoGroupByResult.prototype.field;
    /** @type {?} */
    CoveoGroupByResult.prototype.values;
}
var CoveoSearchResponse = /** @class */ (function () {
    function CoveoSearchResponse(results, totalCount, totalCountFiltered, groupByResults) {
        this.results = results;
        this.totalCount = totalCount;
        this.totalCountFiltered = totalCountFiltered;
        this.groupByResults = groupByResults;
    }
    return CoveoSearchResponse;
}());
if (false) {
    /** @type {?} */
    CoveoSearchResponse.prototype.results;
    /** @type {?} */
    CoveoSearchResponse.prototype.totalCount;
    /** @type {?} */
    CoveoSearchResponse.prototype.totalCountFiltered;
    /** @type {?} */
    CoveoSearchResponse.prototype.groupByResults;
}
/** @enum {number} */
var SearchOperationsStatusState = {
    Idle: 0,
    Active: 1,
};
SearchOperationsStatusState[SearchOperationsStatusState.Idle] = 'Idle';
SearchOperationsStatusState[SearchOperationsStatusState.Active] = 'Active';
var SearchOperationsStatus = /** @class */ (function () {
    function SearchOperationsStatus(status, state) {
        this.status = status;
        this.state = state;
    }
    return SearchOperationsStatus;
}());
if (false) {
    /** @type {?} */
    SearchOperationsStatus.prototype.status;
    /** @type {?} */
    SearchOperationsStatus.prototype.state;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function SearchServiceConfig() { }
if (false) {
    /** @type {?} */
    SearchServiceConfig.prototype.accessKey;
    /** @type {?} */
    SearchServiceConfig.prototype.index;
    /** @type {?} */
    SearchServiceConfig.prototype.searchUrl;
    /** @type {?} */
    SearchServiceConfig.prototype.pipeline;
}
/** @type {?} */
var SEARCH_CONFIG = new InjectionToken('Search service config');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SearchState = /** @class */ (function () {
    function SearchState(query, facets, sort, distance, lat, lng, keywords, lockFacet, page, cq, refineLocation) {
        this.query = query;
        this.facets = facets;
        this.sort = sort;
        this.distance = distance;
        this.lat = lat;
        this.lng = lng;
        this.keywords = keywords;
        this.lockFacet = lockFacet;
        this.page = page;
        this.cq = cq;
        this.refineLocation = refineLocation;
        if (!this.facets) {
            this.facets = {};
        }
        if (!this.sort) {
            this.sort = 'ascending';
        }
    }
    return SearchState;
}());
if (false) {
    /** @type {?} */
    SearchState.prototype.query;
    /** @type {?} */
    SearchState.prototype.facets;
    /** @type {?} */
    SearchState.prototype.sort;
    /** @type {?} */
    SearchState.prototype.distance;
    /** @type {?} */
    SearchState.prototype.lat;
    /** @type {?} */
    SearchState.prototype.lng;
    /** @type {?} */
    SearchState.prototype.keywords;
    /** @type {?} */
    SearchState.prototype.lockFacet;
    /** @type {?} */
    SearchState.prototype.page;
    /** @type {?} */
    SearchState.prototype.cq;
    /** @type {?} */
    SearchState.prototype.refineLocation;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SearchNavigatorService = /** @class */ (function () {
    function SearchNavigatorService(location, _document, config) {
        this.location = location;
        this.config = config;
        this.urlUpdated = new Subject();
        this.document = document;
    }
    /**
     * @param {?} state
     * @return {?}
     */
    SearchNavigatorService.prototype.setState = /**
     * @param {?} state
     * @return {?}
     */
    function (state) {
        /** @type {?} */
        var querystring = this.getStateQueryString(state);
        /** @type {?} */
        var url = this.config.searchUrl + '?' + querystring;
        window.location.href = url;
    };
    /**
     * @return {?}
     */
    SearchNavigatorService.prototype.initFromQueryString = /**
     * @return {?}
     */
    function () {
        var e_1, _a;
        /** @type {?} */
        var params = parse(window.location.search.replace(/^\?/, ''));
        /** @type {?} */
        var state = new SearchState();
        if (params.hasOwnProperty('query') && params['query']) {
            state.query = (/** @type {?} */ (params['query']));
        }
        if (params.hasOwnProperty('facets') && params['facets']) {
            /** @type {?} */
            var facetFromString = (/**
             * @param {?} f
             * @param {?} state
             * @return {?}
             */
            function (f, state) {
                /** @type {?} */
                var tokens = f.split('=');
                state.facets[tokens[0]] = new Facet(tokens[0], new Set(tokens[1].split(';')));
            });
            if (Array.isArray(params['facets'])) {
                try {
                    for (var _b = __values(params['facets']), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var f = _c.value;
                        facetFromString(f, state);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            else {
                facetFromString((/** @type {?} */ (params['facets'])), state);
            }
        }
        if (params.hasOwnProperty('sort') && params['sort']) {
            state.sort = (/** @type {?} */ (params['sort']));
        }
        if (params.hasOwnProperty('distance') && params['distance']) {
            state.distance = parseInt((/** @type {?} */ (params['distance'])));
        }
        if (params.hasOwnProperty('lat') && params['lat']) {
            state.lat = parseFloat((/** @type {?} */ (params['lat'])));
        }
        if (params.hasOwnProperty('lng') && params['lng']) {
            state.lng = parseFloat((/** @type {?} */ (params['lng'])));
        }
        if (params.hasOwnProperty('keywords') && params['keywords']) {
            state.keywords = (/** @type {?} */ (params['keywords']));
        }
        if (params.hasOwnProperty('lockFacet') && params['lockFacet']) {
            state.lockFacet = (/** @type {?} */ (params['lockFacet']));
        }
        if (params.hasOwnProperty('page') && params['page']) {
            state.page = parseInt((/** @type {?} */ (params['page'])));
        }
        if (params.hasOwnProperty('l05') && params['l05']) {
            state.cq = (/** @type {?} */ (params['l05']));
        }
        return state;
    };
    /**
     * @param {?} state
     * @return {?}
     */
    SearchNavigatorService.prototype.getStateQueryString = /**
     * @param {?} state
     * @return {?}
     */
    function (state) {
        /** @type {?} */
        var params = {};
        if (state.query) {
            params['query'] = state.query;
        }
        if (state.facets) {
            params['facets'] = this.facetQueryStringList(state.facets);
        }
        if (state.sort) {
            params['sort'] = state.sort;
        }
        if (state.distance) {
            params['distance'] = state.distance;
        }
        if (state.lat) {
            params['lat'] = state.lat;
        }
        if (state.lng) {
            params['lng'] = state.lng;
        }
        if (state.keywords) {
            params['keywords'] = state.keywords;
        }
        if (state.lockFacet) {
            params['lockFacet'] = state.lockFacet;
        }
        if (state.page) {
            params['page'] = state.page;
        }
        return stringify(params);
    };
    /**
     * @param {?} facets
     * @return {?}
     */
    SearchNavigatorService.prototype.facetQueryStringList = /**
     * @param {?} facets
     * @return {?}
     */
    function (facets) {
        /** @type {?} */
        var result = [];
        for (var f in facets) {
            if (facets.hasOwnProperty(f)) {
                result.push(f + "=" + Array.from(facets[f].selectedValues).join(';'));
            }
        }
        return result;
    };
    SearchNavigatorService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    SearchNavigatorService.ctorParameters = function () { return [
        { type: Location$1 },
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [SEARCH_CONFIG,] }] }
    ]; };
    /** @nocollapse */ SearchNavigatorService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SearchNavigatorService_Factory() { return new SearchNavigatorService(ɵɵinject(Location$1), ɵɵinject(DOCUMENT), ɵɵinject(SEARCH_CONFIG)); }, token: SearchNavigatorService, providedIn: "root" });
    return SearchNavigatorService;
}());
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SearchNavigatorService.prototype.document;
    /** @type {?} */
    SearchNavigatorService.prototype.urlUpdated;
    /**
     * @type {?}
     * @protected
     */
    SearchNavigatorService.prototype.location;
    /**
     * @type {?}
     * @protected
     */
    SearchNavigatorService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function httpOptions() { }
if (false) {
    /** @type {?} */
    httpOptions.prototype.headers;
    /** @type {?} */
    httpOptions.prototype.params;
}
var CoveoAnalyticsResponse = /** @class */ (function () {
    function CoveoAnalyticsResponse() {
    }
    return CoveoAnalyticsResponse;
}());
if (false) {
    /** @type {?} */
    CoveoAnalyticsResponse.prototype.searchEventUid;
    /** @type {?} */
    CoveoAnalyticsResponse.prototype.visitId;
    /** @type {?} */
    CoveoAnalyticsResponse.prototype.visitorId;
}
var CoveoAnalyticsPayload = /** @class */ (function () {
    function CoveoAnalyticsPayload(event, actionCause) {
        this.event = event;
        this.actionCause = actionCause;
        this.customData = {};
        this.language = "en";
        this.originLevel1 = "clinical";
        this.originLevel2 = "FindAProvider";
    }
    return CoveoAnalyticsPayload;
}());
if (false) {
    /** @type {?} */
    CoveoAnalyticsPayload.prototype.queryText;
    /** @type {?} */
    CoveoAnalyticsPayload.prototype.advancedQuery;
    /** @type {?} */
    CoveoAnalyticsPayload.prototype.customData;
    /** @type {?} */
    CoveoAnalyticsPayload.prototype.language;
    /** @type {?} */
    CoveoAnalyticsPayload.prototype.originLevel1;
    /** @type {?} */
    CoveoAnalyticsPayload.prototype.originLevel2;
    /** @type {?} */
    CoveoAnalyticsPayload.prototype.responseTime;
    /** @type {?} */
    CoveoAnalyticsPayload.prototype.searchQueryUid;
    /** @type {?} */
    CoveoAnalyticsPayload.prototype.documentPosition;
    /** @type {?} */
    CoveoAnalyticsPayload.prototype.documentTitle;
    /** @type {?} */
    CoveoAnalyticsPayload.prototype.documentUri;
    /** @type {?} */
    CoveoAnalyticsPayload.prototype.documentUriHash;
    /** @type {?} */
    CoveoAnalyticsPayload.prototype.documentUrl;
    /** @type {?} */
    CoveoAnalyticsPayload.prototype.eventType;
    /** @type {?} */
    CoveoAnalyticsPayload.prototype.eventValue;
    /** @type {?} */
    CoveoAnalyticsPayload.prototype.sourceName;
    /** @type {?} */
    CoveoAnalyticsPayload.prototype.event;
    /** @type {?} */
    CoveoAnalyticsPayload.prototype.actionCause;
}
var CoveoAnalyticsService = /** @class */ (function () {
    function CoveoAnalyticsService(http, config, cookieService) {
        this.http = http;
        this.config = config;
        this.cookieService = cookieService;
        this.label = "Coveo Analytics";
        this.url = "https://carolinashealthcare.org.coveo.com/rest/ua/v15/analytics";
        this.logToConsole = false;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: "Bearer " + this.config.accessKey,
            }),
            params: new HttpParams({})
        };
        if (this.cookieService.check("coveo_visitor_id")) {
            /** @type {?} */
            var visitorId = this.cookieService.get("coveo_visitor_id");
            this.log("Existing visitorId [" + visitorId + "] obtained from cookie.");
            this.httpOptions.params = new HttpParams().set("visitor", visitorId);
        }
    }
    /**
     * @param {?} accessKey
     * @return {?}
     */
    CoveoAnalyticsService.prototype.setAccessKey = /**
     * @param {?} accessKey
     * @return {?}
     */
    function (accessKey) {
        this.httpOptions.headers = this.httpOptions.headers.set("Authorization", 'Bearer ' + accessKey);
    };
    /**
     * @return {?}
     */
    CoveoAnalyticsService.prototype.interfaceLoad = /**
     * @return {?}
     */
    function () {
        this.log("Interface loaded.");
        this.payload = new CoveoAnalyticsPayload("search", "interfaceLoad");
    };
    /**
     * @param {?} queryText
     * @return {?}
     */
    CoveoAnalyticsService.prototype.searchBoxSubmit = /**
     * @param {?} queryText
     * @return {?}
     */
    function (queryText) {
        this.log("Search Box submitted with value [" + queryText + "].");
        this.payload = new CoveoAnalyticsPayload("search", "searchBoxSubmit");
    };
    /**
     * @return {?}
     */
    CoveoAnalyticsService.prototype.searchBoxClear = /**
     * @return {?}
     */
    function () {
        this.log("Search Box cleared.");
        this.payload = new CoveoAnalyticsPayload("search", "searchBoxClear");
    };
    /**
     * @param {?} suggestion
     * @return {?}
     */
    CoveoAnalyticsService.prototype.selectSuggestion = /**
     * @param {?} suggestion
     * @return {?}
     */
    function (suggestion) {
        this.log("Search suggestion [" + suggestion.value + "] selected.");
        this.payload = new CoveoAnalyticsPayload("search", "facetSelect");
        this.payload.customData = {
            facetField: suggestion.type,
            facetId: suggestion.suggestValue,
            facetTitle: suggestion.title,
            facetValue: suggestion.value
        };
    };
    /**
     * @param {?} facetOptionValue
     * @param {?} facetOption
     * @return {?}
     */
    CoveoAnalyticsService.prototype.selectFacetValue = /**
     * @param {?} facetOptionValue
     * @param {?} facetOption
     * @return {?}
     */
    function (facetOptionValue, facetOption) {
        this.log("Facet [" + facetOptionValue.value + "] added.");
        this.payload = new CoveoAnalyticsPayload("search", "facetSelect");
        this.payload.customData = {
            facetField: facetOption.field,
            facetId: facetOption.title,
            facetTitle: facetOptionValue.value,
            facetValue: facetOptionValue.lookupValue
        };
    };
    /**
     * @param {?} facetOptionValue
     * @param {?} facetOption
     * @return {?}
     */
    CoveoAnalyticsService.prototype.unselectFacetValue = /**
     * @param {?} facetOptionValue
     * @param {?} facetOption
     * @return {?}
     */
    function (facetOptionValue, facetOption) {
        this.log("Facet [" + facetOptionValue.value + "] removed.");
        this.payload = new CoveoAnalyticsPayload("search", "facetDeselect");
        this.payload.customData = {
            facetField: facetOption.field,
            facetId: facetOption.title,
            facetTitle: facetOptionValue.value,
            facetValue: facetOptionValue.lookupValue
        };
    };
    /**
     * @return {?}
     */
    CoveoAnalyticsService.prototype.clearFacets = /**
     * @return {?}
     */
    function () {
        this.log("Facets cleared.");
        this.payload = new CoveoAnalyticsPayload("search", "facetClearAll");
    };
    /**
     * @param {?} sort
     * @return {?}
     */
    CoveoAnalyticsService.prototype.changeSortBy = /**
     * @param {?} sort
     * @return {?}
     */
    function (sort) {
        if (sort == "ascending") {
            sort = "@wfslastname ascending";
        }
        else if (sort == "descending") {
            sort = "@wfslastname descending";
        }
        this.log("Sort changed to [" + sort + "].");
        this.payload = new CoveoAnalyticsPayload("search", "resultsSort");
        this.payload.customData = {
            resultsSortBy: sort
        };
        this.payload.eventType = "N/A";
        this.payload.eventValue = "N/A";
    };
    /**
     * @param {?} page
     * @param {?} source
     * @return {?}
     */
    CoveoAnalyticsService.prototype.goToPage = /**
     * @param {?} page
     * @param {?} source
     * @return {?}
     */
    function (page, source) {
        this.log("Go to [" + source + "] page [" + page + "]");
        switch (source) {
            case "next":
                source = "pagerNext";
                break;
            case "prev":
                source = "pagerPrev";
                break;
            default:
                source = "pagerNumber";
                break;
        }
        this.payload = new CoveoAnalyticsPayload("custom", "N/A");
        this.payload.customData = {
            pagerNumber: page
        };
        this.payload.eventType = "getMoreResults";
        this.payload.eventValue = source;
    };
    /**
     * @param {?} result
     * @return {?}
     */
    CoveoAnalyticsService.prototype.resultClick = /**
     * @param {?} result
     * @return {?}
     */
    function (result) {
        var _this = this;
        this.log("Result [" + result.fullName + "] clicked.");
        this.payload = new CoveoAnalyticsPayload("click", "documentOpen");
        this.payload.customData = {
            "contentIDKey": "permanentid",
            "contentIDValue": result.permanentId,
            "author": result.author,
            "documentTitle": result.title,
            "documentURL": result.uri
        };
        this.payload.documentPosition = 1;
        this.payload.documentTitle = result.title;
        this.payload.documentUri = result.uri;
        this.payload.documentUriHash = result.permanentId;
        this.payload.documentUrl = result.cmsUri;
        this.payload.searchQueryUid = this.lastQueryUid;
        this.payload.sourceName = window.location.href;
        this.http.post(this.url + "/" + this.payload.event, this.payload, this.httpOptions).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
            _this.eventSuccess(response);
            window.location.href = _this.payload.documentUri;
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.eventError(error);
            window.location.href = _this.payload.documentUri;
        }));
    };
    /**
     * @param {?} response
     * @return {?}
     */
    CoveoAnalyticsService.prototype.searchCompleted = /**
     * @param {?} response
     * @return {?}
     */
    function (response) {
        var _this = this;
        if (this.payload) {
            this.log("Submitted search [" + response.searchUid + "] completed in [" + response.duration + "]ms.");
            this.payload.responseTime = response.duration;
            this.payload.searchQueryUid = response.searchUid;
            this.payload.queryText = response.basicExpression ? response.basicExpression : "";
            this.payload.advancedQuery = response.advancedExpression ? response.advancedExpression : "";
            this.http.post(this.url + "/" + this.payload.event, this.payload, this.httpOptions).subscribe((/**
             * @param {?} response
             * @return {?}
             */
            function (response) {
                _this.eventSuccess(response);
                _this.lastQueryUid = response.searchEventUid;
                _this.payload = null;
            }), (/**
             * @param {?} error
             * @return {?}
             */
            function (error) {
                _this.eventError(error);
                _this.payload = null;
            }));
        }
    };
    /**
     * @private
     * @param {?} response
     * @return {?}
     */
    CoveoAnalyticsService.prototype.eventSuccess = /**
     * @private
     * @param {?} response
     * @return {?}
     */
    function (response) {
        if (!this.httpOptions.params.get("visitor")) {
            this.cookieService.set("coveo_visitor_id", response.visitorId);
            this.httpOptions.params = new HttpParams().set("visitor", response.visitorId);
        }
        this.log("Successfully logged [" + this.payload.event + "] event for visitorId [" + response.visitorId + "].");
    };
    /**
     * @private
     * @param {?} response
     * @return {?}
     */
    CoveoAnalyticsService.prototype.eventError = /**
     * @private
     * @param {?} response
     * @return {?}
     */
    function (response) {
        this.log("[" + response.error.message + "]");
    };
    /**
     * @private
     * @param {?} message
     * @return {?}
     */
    CoveoAnalyticsService.prototype.log = /**
     * @private
     * @param {?} message
     * @return {?}
     */
    function (message) {
        if (this.logToConsole) {
            console.log(this.label + ": " + message);
        }
    };
    CoveoAnalyticsService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    CoveoAnalyticsService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: [SEARCH_CONFIG,] }] },
        { type: CookieService }
    ]; };
    /** @nocollapse */ CoveoAnalyticsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CoveoAnalyticsService_Factory() { return new CoveoAnalyticsService(ɵɵinject(HttpClient), ɵɵinject(SEARCH_CONFIG), ɵɵinject(CookieService)); }, token: CoveoAnalyticsService, providedIn: "root" });
    return CoveoAnalyticsService;
}());
if (false) {
    /** @type {?} */
    CoveoAnalyticsService.prototype.label;
    /** @type {?} */
    CoveoAnalyticsService.prototype.url;
    /** @type {?} */
    CoveoAnalyticsService.prototype.logToConsole;
    /** @type {?} */
    CoveoAnalyticsService.prototype.httpOptions;
    /** @type {?} */
    CoveoAnalyticsService.prototype.payload;
    /** @type {?} */
    CoveoAnalyticsService.prototype.lastQueryUid;
    /**
     * @type {?}
     * @private
     */
    CoveoAnalyticsService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    CoveoAnalyticsService.prototype.config;
    /**
     * @type {?}
     * @private
     */
    CoveoAnalyticsService.prototype.cookieService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function httpOptions$1() { }
if (false) {
    /** @type {?} */
    httpOptions$1.prototype.headers;
}
var SearchService = /** @class */ (function () {
    function SearchService(http, config, searchNavigator, analytics) {
        this.http = http;
        this.config = config;
        this.searchNavigator = searchNavigator;
        this.analytics = analytics;
        this.numberOfResults = 25;
        this.resultsUpdated = new BehaviorSubject([]);
        this.results = [];
        this.state = new SearchState();
        this.searchStateChanged = new BehaviorSubject(this.state);
        this.suggestActive = false;
        this.resultsActive = false;
        this.searchOperationChanges = new BehaviorSubject(new SearchOperationsStatus('', SearchOperationsStatusState.Idle));
        this.facetOptions = {
            '@wfsspecialties': new FacetOption('@wfsspecialties', 'Specialty', 20, [], ['@wfsspecialtiessynonyms']),
            '@wfslocationname': new FacetOption('@wfslocationname', 'Provider Location', 20, []),
            '@wfsonlineschedule': new FacetOption('@wfsonlineschedule', 'Online Scheduling Available', 2, [], [], true),
            '@wfsacceptingnewpatients': new FacetOption('@wfsacceptingnewpatients', 'Accepting New Patients', 2, [], [], true),
            '@wfsconditions': new FacetOption('@wfsconditions', 'Conditions', 20, []),
            '@wfstreatments': new FacetOption('@wfstreatments', 'Treatments', 20, []),
            '@wfsprovidertype': new FacetOption('@wfsprovidertype', 'Provider Type', 20, []),
            '@wfsgender': new FacetOption('@wfsgender', 'Gender', 20),
            '@wfslanguagespoken': new FacetOption('@wfslanguagespoken', 'Languages Spoken in Addition to English', 20, []),
        };
        this.hidden = false;
        this.build();
    }
    /**
     * @return {?}
     */
    SearchService.prototype.build = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: "Bearer " + this.config.accessKey,
            })
        };
        this.queryLimiter = "@syssite=\"clinical\" AND @wfscontenttype=\"Physician Profile\" AND @syssource=\"" + this.config.index + "\"";
        this.searchNavigator.urlUpdated.subscribe((/**
         * @return {?}
         */
        function () {
            _this.initFromUrl();
        }));
    };
    /**
     * @param {?} key
     * @param {?} value
     * @param {?=} rebuild
     * @return {?}
     */
    SearchService.prototype.setConfig = /**
     * @param {?} key
     * @param {?} value
     * @param {?=} rebuild
     * @return {?}
     */
    function (key, value, rebuild) {
        if (rebuild === void 0) { rebuild = false; }
        this.config[key] = value;
        if (rebuild) {
            this.build();
        }
    };
    /**
     * @return {?}
     */
    SearchService.prototype.getPage = /**
     * @return {?}
     */
    function () {
        return this.state.page || 0;
    };
    /**
     * @param {?} page
     * @return {?}
     */
    SearchService.prototype.setPage = /**
     * @param {?} page
     * @return {?}
     */
    function (page) {
        this.state.page = page;
        this.searchStateChanged.next(this.state);
    };
    /**
     * @return {?}
     */
    SearchService.prototype.getPageSize = /**
     * @return {?}
     */
    function () {
        return this.numberOfResults;
    };
    /**
     * @param {?} sort
     * @return {?}
     */
    SearchService.prototype.setSort = /**
     * @param {?} sort
     * @return {?}
     */
    function (sort) {
        this.state.sort = sort;
        this.searchStateChanged.next(this.state);
    };
    /**
     * @param {?} location
     * @return {?}
     */
    SearchService.prototype.setRefineLocation = /**
     * @param {?} location
     * @return {?}
     */
    function (location) {
        this.state.refineLocation = location;
        this.searchStateChanged.next(this.state);
    };
    /**
     * @param {?} lat
     * @param {?} lng
     * @return {?}
     */
    SearchService.prototype.setLatLng = /**
     * @param {?} lat
     * @param {?} lng
     * @return {?}
     */
    function (lat, lng) {
        this.state.lat = lat;
        this.state.lng = lng;
        this.searchStateChanged.next(this.state);
    };
    /**
     * @return {?}
     */
    SearchService.prototype.hasLatLng = /**
     * @return {?}
     */
    function () {
        return Boolean(this.state.lat) || Boolean(this.state.lng);
    };
    /**
     * @return {?}
     */
    SearchService.prototype.getLatLng = /**
     * @return {?}
     */
    function () {
        return [this.state.lat, this.state.lng];
    };
    /**
     * @param {?} distance
     * @return {?}
     */
    SearchService.prototype.setDistance = /**
     * @param {?} distance
     * @return {?}
     */
    function (distance) {
        this.state.distance = distance;
        this.searchStateChanged.next(this.state);
    };
    /**
     * @return {?}
     */
    SearchService.prototype.getDistance = /**
     * @return {?}
     */
    function () {
        return this.state.distance;
    };
    /**
     * @return {?}
     */
    SearchService.prototype.clearCQ = /**
     * @return {?}
     */
    function () {
        this.state.cq = null;
    };
    /**
     * @param {?} query
     * @return {?}
     */
    SearchService.prototype.setQuery = /**
     * @param {?} query
     * @return {?}
     */
    function (query) {
        this.state.query = query;
        this.searchStateChanged.next(this.state);
    };
    /**
     * @return {?}
     */
    SearchService.prototype.getQuery = /**
     * @return {?}
     */
    function () {
        if (this.state.query) {
            return this.state.query;
        }
        if (this.state.keywords) {
            return this.state.keywords;
        }
    };
    /**
     * @param {?} keywords
     * @return {?}
     */
    SearchService.prototype.setKeywords = /**
     * @param {?} keywords
     * @return {?}
     */
    function (keywords) {
        this.state.keywords = keywords;
        this.searchStateChanged.next(this.state);
    };
    /**
     * @param {?} field
     * @param {?} value
     * @return {?}
     */
    SearchService.prototype.setLockFacet = /**
     * @param {?} field
     * @param {?} value
     * @return {?}
     */
    function (field, value) {
        this.state.lockFacet = field + "|" + value;
        this.searchStateChanged.next(this.state);
    };
    /**
     * @return {?}
     */
    SearchService.prototype.getSearchState = /**
     * @return {?}
     */
    function () {
        return this.state;
    };
    /**
     * @return {?}
     */
    SearchService.prototype.resetSearch = /**
     * @return {?}
     */
    function () {
        this.clearCQ();
        this.reset();
        this.refresh();
    };
    /**
     * Clears the search state and runs a fresh search.
     * @param query the query to search for
     */
    /**
     * Clears the search state and runs a fresh search.
     * @param {?} query the query to search for
     * @return {?}
     */
    SearchService.prototype.search = /**
     * Clears the search state and runs a fresh search.
     * @param {?} query the query to search for
     * @return {?}
     */
    function (query) {
        this.state = new SearchState(query);
        this.searchStateChanged.next(this.state);
        return this.getResults();
    };
    /**
     * Executes the query according to the search state, returns the results via an
     * observable and triggers related subjects.
     */
    /**
     * Executes the query according to the search state, returns the results via an
     * observable and triggers related subjects.
     * @return {?}
     */
    SearchService.prototype.getResults = /**
     * Executes the query according to the search state, returns the results via an
     * observable and triggers related subjects.
     * @return {?}
     */
    function () {
        var _this = this;
        var e_1, _a, e_2, _b;
        // Add current facet state
        /** @type {?} */
        var facetQuery = [];
        for (var facet in this.state.facets) {
            if (this.state.facets.hasOwnProperty(facet)) {
                try {
                    for (var _c = __values(this.state.facets[facet].selectedValues), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var v = _d.value;
                        /** @type {?} */
                        var query = '(' + facet + '==("' + v + '"))';
                        if (this.facetOptions[facet].synonymFields.length) {
                            /** @type {?} */
                            var queryItems = [query];
                            try {
                                for (var _e = __values(this.facetOptions[facet].synonymFields), _f = _e.next(); !_f.done; _f = _e.next()) {
                                    var f = _f.value;
                                    queryItems.push('(' + f + '=("' + v + '"))');
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                            query = '(' + queryItems.join(' OR ') + ')';
                        }
                        facetQuery.push(query);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        }
        if (this.state.sort === 'distance' && !(this.state.lat && this.state.lng)) {
            this.state.sort = 'ascending';
            this.searchStateChanged.next(this.state);
        }
        /** @type {?} */
        var body = {
            q: this.state.query || '',
            cq: this.queryLimiter,
            pipeline: this.config.pipeline,
            sortCriteria: '@wfslastname ' + this.state.sort,
            debug: true,
            groupBy: [],
            numberOfResults: this.numberOfResults,
            firstResult: this.state.page * this.numberOfResults,
        };
        if (this.state.lat && this.state.lng) {
            body['queryFunctions'] = [
                {
                    'fieldName': 'distance1',
                    'function': "dist(@wfsloc1lat, @wfsloc1long, " + this.state.lat + ", " + this.state.lng + ")"
                },
                {
                    'fieldName': 'distance2',
                    'function': "dist(@wfsloc2lat, @wfsloc2long, " + this.state.lat + ", " + this.state.lng + ")"
                },
                {
                    'fieldName': 'distance3',
                    'function': "dist(@wfsloc3lat, @wfsloc3long, " + this.state.lat + ", " + this.state.lng + ")"
                },
                {
                    'fieldName': 'distance4',
                    'function': "dist(@wfsloc4lat, @wfsloc4long, " + this.state.lat + ", " + this.state.lng + ")"
                },
                {
                    'fieldName': 'distance',
                    'function': "min(@distance1, @distance2, @distance3, @distance4)"
                }
            ];
            facetQuery.push('@distance > 0');
            if (this.state.distance) {
                facetQuery.push("(@distance < " + this.state.distance * 1609.34 + ")");
            }
            body['sortCriteria'] = '@distance ascending';
        }
        body['aq'] = facetQuery.join(' AND ');
        if (this.state.cq) {
            body['cq'] += ' AND ' + this.state.cq;
        }
        // Add facet group by
        for (var facet in this.facetOptions) {
            if (this.facetOptions.hasOwnProperty(facet)) {
                /** @type {?} */
                var opt = this.facetOptions[facet];
                body.groupBy.push({ field: opt.field, maximumNumberOfValues: 500, sortCriteria: 'occurences' });
            }
        }
        this.resultsActive = true;
        this.searchOperationChanges.next({ status: 'resultsStart', state: SearchOperationsStatusState.Active });
        return this.http.post('https://carolinashealthcare.org.coveo.com/rest/search/v2', body, this.httpOptions).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
            var e_3, _a;
            _this.totalResults = response.totalCountFiltered;
            /** @type {?} */
            var results = [];
            response.results.forEach((/**
             * @param {?} result
             * @return {?}
             */
            function (result) {
                /** @type {?} */
                var res = new SearchResult(result.raw['urihash'], result['uri'], result.raw['wfsnavtitle'], result.raw['uri'].replace(/https?:\/\/[^\/]+/i, ""), result.raw['wfspositiontitle'], result.raw['wfsisspecialist'], result.raw['wfsspecialties'], result.raw['wfsprovidertype'], result.raw['wfslanguagespoken'], result.raw['wfspersonimage'], result.raw['wfsacceptingnewpatients'], result.raw['wfsez120xistingpatients'], result.raw['wfsfirstname'], result.raw['wfslastname'], result.raw['wfsgender'], result.raw['wfsonlineschedule'], result.raw['wfsdirectscheduling'], result.raw['wfsosvt'], result.raw['wfspei'], result.raw['wfsmsgpath'], result.raw['wfsfullname'], result['author'], parseFloat(result.raw['wfsoverallrating']), parseFloat(result.raw['wfsnumberofratings']), (result.raw['wfsshowratings'] === "true"));
                for (var i = 1; i <= 4; i++) {
                    if (!result.raw["wfsloc" + i + "lat"] || !result.raw["wfsloc" + i + "long"]) {
                        continue;
                    }
                    if (!(result.raw["wfsloc" + i + "address1"] ||
                        result.raw["wfsloc" + i + "address2"] ||
                        result.raw["wfsloc" + i + "floorsuite"] ||
                        result.raw["wfsloc" + i + "name"] ||
                        result.raw["wfsloc" + i + "newpatientslocalphone"] ||
                        result.raw["wfsloc" + i + "pageurl"] ||
                        result.raw["distance" + i])) {
                        continue;
                    }
                    res.locations.push(new Location(result.raw["wfsloc" + i + "address1"], result.raw["wfsloc" + i + "address2"], result.raw["wfsloc" + i + "floorsuite"], result.raw["wfsloc" + i + "name"], result.raw["wfsloc" + i + "newpatientslocalphone"], result.raw["wfsloc" + i + "pageurl"], result.raw["distance" + i]));
                }
                res.locations.sort((/**
                 * @param {?} first
                 * @param {?} second
                 * @return {?}
                 */
                function (first, second) {
                    if (first.distance == second.distance)
                        return 0;
                    return first.distance < second.distance ? -1 : 1;
                }));
                results.push(res);
            }));
            try {
                for (var _b = __values(response.groupByResults), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var groupByResult = _c.value;
                    _this.facetOptions['@' + groupByResult.field].currentOptions = groupByResult.values;
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
            _this.facetOptions['@wfslocationname'] = _this.excludeFacetOptions(_this.facetOptions['@wfslocationname'], ["Wake Forest Baptist Health"]);
            _this.results = results;
            _this.resultsUpdated.next(results);
            _this.resultsActive = false;
            _this.searchOperationChanges.next({ status: 'resultsFinish', state: SearchOperationsStatusState.Idle });
            _this.analytics.searchCompleted(response);
            return results;
        })));
    };
    /**
     * @param {?} facetOption
     * @param {?} exclusions
     * @return {?}
     */
    SearchService.prototype.excludeFacetOptions = /**
     * @param {?} facetOption
     * @param {?} exclusions
     * @return {?}
     */
    function (facetOption, exclusions) {
        for (var i = 0; i < facetOption.currentOptions.length; i++) {
            if (exclusions.includes(facetOption.currentOptions[i].value)) {
                facetOption.currentOptions.splice(i, 1);
            }
        }
        return facetOption;
    };
    /**
     * Executes a suggest query, returns results via an observable and updates related
     * subjects.
     * @param query the query to get suggestions for.
     */
    /**
     * Executes a suggest query, returns results via an observable and updates related
     * subjects.
     * @param {?} query the query to get suggestions for.
     * @return {?}
     */
    SearchService.prototype.suggest = /**
     * Executes a suggest query, returns results via an observable and updates related
     * subjects.
     * @param {?} query the query to get suggestions for.
     * @return {?}
     */
    function (query) {
        var _this = this;
        /** @type {?} */
        var body = {
            batch: [
                {
                    pattern: '*' + query + '*',
                    field: '@wfsspecialties',
                    pipeline: this.config.pipeline,
                    _wfbhFieldName: 'Specialty',
                    debug: true,
                    maximumNumberOfValues: 5,
                    queryOverride: this.queryLimiter
                },
                {
                    pattern: '*' + query + '*',
                    field: '@wfsfirstlastname',
                    pipeline: this.config.pipeline,
                    _wfbhFieldName: 'Provider',
                    debug: true,
                    maximumNumberOfValues: 5,
                    queryOverride: this.queryLimiter
                },
                {
                    pattern: '*' + query + '*',
                    field: '@wfsconditions',
                    pipeline: this.config.pipeline,
                    _wfbhFieldName: 'Condition',
                    debug: true,
                    maximumNumberOfValues: 5,
                    queryOverride: this.queryLimiter
                },
                {
                    pattern: '*' + query + '*',
                    field: '@wfstreatments',
                    pipeline: this.config.pipeline,
                    _wfbhFieldName: 'Treatment',
                    debug: true,
                    maximumNumberOfValues: 5,
                    queryOverride: this.queryLimiter
                },
                {
                    pattern: '*' + query + '*',
                    field: '@wfslocationname',
                    pipeline: this.config.pipeline,
                    _wfbhFieldName: 'Location',
                    debug: true,
                    maximumNumberOfValues: 5,
                    queryOverride: this.queryLimiter
                }
            ]
        };
        this.suggestActive = true;
        this.searchOperationChanges.next({ status: 'suggestStart', state: SearchOperationsStatusState.Active });
        return this.http.post('https://carolinashealthcare.org.coveo.com/rest/search/v2/values/batch', body, this.httpOptions).pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
            /** @type {?} */
            var results = [];
            /** @type {?} */
            var i = 0;
            response.batch.forEach((/**
             * @param {?} b
             * @return {?}
             */
            function (b) {
                b.forEach((/**
                 * @param {?} result
                 * @return {?}
                 */
                function (result) {
                    results.push(new Suggestion(result.value, result.lookupValue, body.batch[i].field === '@wfsfirstlastname' ? 'fulltext' : 'field', body.batch[i].field, body.batch[i]._wfbhFieldName, result.numberOfResults));
                }));
                i++;
            }));
            _this.suggestActive = false;
            _this.searchOperationChanges.next({ status: 'suggestFinished', state: SearchOperationsStatusState.Idle });
            return results;
        })));
    };
    /**
     * Updates the query string via navigator and refreshes search results.
     */
    /**
     * Updates the query string via navigator and refreshes search results.
     * @return {?}
     */
    SearchService.prototype.refresh = /**
     * Updates the query string via navigator and refreshes search results.
     * @return {?}
     */
    function () {
        this.searchNavigator.setState(this.getSearchState());
        this.getResults().subscribe();
    };
    /**
     * Wipes the current search state and runs a new, queryless search.
     */
    /**
     * Wipes the current search state and runs a new, queryless search.
     * @return {?}
     */
    SearchService.prototype.reset = /**
     * Wipes the current search state and runs a new, queryless search.
     * @return {?}
     */
    function () {
        return this.search('');
    };
    /**
     * @return {?}
     */
    SearchService.prototype.initFromUrl = /**
     * @return {?}
     */
    function () {
        this.state = this.searchNavigator.initFromQueryString();
        this.searchStateChanged.next(this.state);
        this.getResults().subscribe();
    };
    /**
     * @param {?} field
     * @param {?} value
     * @return {?}
     */
    SearchService.prototype.toggleFacet = /**
     * @param {?} field
     * @param {?} value
     * @return {?}
     */
    function (field, value) {
        if (this.isFacetSelected(field, value)) {
            this.unselectFacet(field, value);
        }
        else {
            this.selectFacet(field, value);
        }
        this.state.page = 0;
        this.searchStateChanged.next(this.state);
    };
    /**
     * @param {?} field
     * @param {?} value
     * @return {?}
     */
    SearchService.prototype.selectFacet = /**
     * @param {?} field
     * @param {?} value
     * @return {?}
     */
    function (field, value) {
        if (!this.state.facets.hasOwnProperty(field)) {
            this.state.facets[field] = new Facet(field);
        }
        this.state.facets[field].selectedValues.add(value);
        this.searchStateChanged.next(this.state);
    };
    /**
     * @param {?} field
     * @param {?} value
     * @return {?}
     */
    SearchService.prototype.unselectFacet = /**
     * @param {?} field
     * @param {?} value
     * @return {?}
     */
    function (field, value) {
        if (!this.state.facets.hasOwnProperty(field)) {
            return;
        }
        this.state.facets[field].selectedValues.delete(value);
        if (this.state.facets[field].selectedValues.size < 1) {
            delete (this.state.facets[field]);
        }
        this.searchStateChanged.next(this.state);
    };
    /**
     * @param {?} field
     * @param {?} value
     * @return {?}
     */
    SearchService.prototype.isFacetSelected = /**
     * @param {?} field
     * @param {?} value
     * @return {?}
     */
    function (field, value) {
        if (!this.state.facets.hasOwnProperty(field)) {
            return false;
        }
        return this.state.facets[field].selectedValues.has(value);
    };
    /**
     * @param {?} field
     * @return {?}
     */
    SearchService.prototype.isAnyFacetSelected = /**
     * @param {?} field
     * @return {?}
     */
    function (field) {
        if (!this.state.facets.hasOwnProperty(field)) {
            return false;
        }
        return this.state.facets[field].selectedValues.size > 0;
    };
    /**
     * @return {?}
     */
    SearchService.prototype.resetFacets = /**
     * @return {?}
     */
    function () {
        this.state.facets = {};
        this.state.lat = null;
        this.state.lng = null;
        this.state.refineLocation = null;
        this.state.distance = null;
        /** @type {?} */
        var lockTokens = this.state.lockFacet ? this.state.lockFacet.split('|', 2) : [];
        this.state.facets = {};
        if (lockTokens.length) {
            this.selectFacet(lockTokens[0], lockTokens[1]);
        }
        this.searchStateChanged.next(this.state);
    };
    /**
     * @return {?}
     */
    SearchService.prototype.hasUnlockedFacet = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var hasKeys = Object.keys(this.state.facets).length > 0;
        ;
        if (!hasKeys) {
            return false;
        }
        if (!this.state.lockFacet) {
            return hasKeys;
        }
        /** @type {?} */
        var lockTokens = this.state.lockFacet.split('|');
        if (lockTokens.length < 2) {
            return hasKeys;
        }
        for (var f in this.state.facets) {
            if (this.state.facets.hasOwnProperty(f)) {
                if (f != lockTokens[0] || this.state.facets[f].selectedValues.size > 1) {
                    return true;
                }
            }
        }
        return false;
    };
    /**
     * @return {?}
     */
    SearchService.prototype.isActive = /**
     * @return {?}
     */
    function () {
        return this.resultsActive || this.suggestActive;
    };
    SearchService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    SearchService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: [SEARCH_CONFIG,] }] },
        { type: SearchNavigatorService },
        { type: CoveoAnalyticsService }
    ]; };
    /** @nocollapse */ SearchService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SearchService_Factory() { return new SearchService(ɵɵinject(HttpClient), ɵɵinject(SEARCH_CONFIG), ɵɵinject(SearchNavigatorService), ɵɵinject(CoveoAnalyticsService)); }, token: SearchService, providedIn: "root" });
    return SearchService;
}());
if (false) {
    /** @type {?} */
    SearchService.prototype.httpOptions;
    /** @type {?} */
    SearchService.prototype.queryLimiter;
    /** @type {?} */
    SearchService.prototype.numberOfResults;
    /** @type {?} */
    SearchService.prototype.resultsUpdated;
    /** @type {?} */
    SearchService.prototype.results;
    /** @type {?} */
    SearchService.prototype.totalResults;
    /**
     * @type {?}
     * @private
     */
    SearchService.prototype.state;
    /** @type {?} */
    SearchService.prototype.searchStateChanged;
    /**
     * @type {?}
     * @private
     */
    SearchService.prototype.suggestActive;
    /**
     * @type {?}
     * @private
     */
    SearchService.prototype.resultsActive;
    /** @type {?} */
    SearchService.prototype.searchOperationChanges;
    /** @type {?} */
    SearchService.prototype.facetOptions;
    /** @type {?} */
    SearchService.prototype.hidden;
    /**
     * @type {?}
     * @private
     */
    SearchService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    SearchService.prototype.config;
    /**
     * @type {?}
     * @private
     */
    SearchService.prototype.searchNavigator;
    /**
     * @type {?}
     * @private
     */
    SearchService.prototype.analytics;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SearchNavigatorSpaService = /** @class */ (function (_super) {
    __extends(SearchNavigatorSpaService, _super);
    function SearchNavigatorSpaService(location, _document, config) {
        var _this = _super.call(this, location, _document, config) || this;
        _this.location = location;
        _this.config = config;
        _this.urlUpdating = false;
        _this.location.onUrlChange((/**
         * @param {?} url
         * @param {?} state
         * @return {?}
         */
        function (url, state) {
            if (!_this.urlUpdating) {
                console.log('Url change!', url);
                _this.urlUpdated.next();
            }
            _this.urlUpdating = false;
        }));
        return _this;
    }
    /**
     * @param {?} state
     * @return {?}
     */
    SearchNavigatorSpaService.prototype.setState = /**
     * @param {?} state
     * @return {?}
     */
    function (state) {
        this.urlUpdating = true;
        /** @type {?} */
        var querystring = this.getStateQueryString(state);
        /** @type {?} */
        var url = this.config.searchUrl + '?' + querystring;
        this.location.go(this.location.normalize(url));
    };
    SearchNavigatorSpaService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    SearchNavigatorSpaService.ctorParameters = function () { return [
        { type: Location$1 },
        { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [SEARCH_CONFIG,] }] }
    ]; };
    /** @nocollapse */ SearchNavigatorSpaService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SearchNavigatorSpaService_Factory() { return new SearchNavigatorSpaService(ɵɵinject(Location$1), ɵɵinject(DOCUMENT), ɵɵinject(SEARCH_CONFIG)); }, token: SearchNavigatorSpaService, providedIn: "root" });
    return SearchNavigatorSpaService;
}(SearchNavigatorService));
if (false) {
    /**
     * @type {?}
     * @protected
     */
    SearchNavigatorSpaService.prototype.urlUpdating;
    /**
     * @type {?}
     * @protected
     */
    SearchNavigatorSpaService.prototype.location;
    /**
     * @type {?}
     * @protected
     */
    SearchNavigatorSpaService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DialogService = /** @class */ (function () {
    function DialogService() {
        this.closed$ = new Subject();
        this.opened$ = new Subject();
    }
    /**
     * @return {?}
     */
    DialogService.prototype.close = /**
     * @return {?}
     */
    function () {
        this.closed$.next(this.current);
    };
    /**
     * @param {?} key
     * @return {?}
     */
    DialogService.prototype.open = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        this.current = key;
        this.opened$.next(key);
    };
    DialogService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    DialogService.ctorParameters = function () { return []; };
    /** @nocollapse */ DialogService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DialogService_Factory() { return new DialogService(); }, token: DialogService, providedIn: "root" });
    return DialogService;
}());
if (false) {
    /** @type {?} */
    DialogService.prototype.closed$;
    /** @type {?} */
    DialogService.prototype.opened$;
    /** @type {?} */
    DialogService.prototype.current;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ActiveFacetComponent = /** @class */ (function () {
    function ActiveFacetComponent(search) {
        this.search = search;
        this.locked = false;
    }
    /**
     * @return {?}
     */
    ActiveFacetComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    ActiveFacetComponent.prototype.removeClick = /**
     * @return {?}
     */
    function () {
        if (this.field == "proxy-distance") {
            this.search.setDistance(null);
            if (!this.search.hasLatLng()) {
                this.search.setSort("ascending");
            }
        }
        else if (this.field == "proxy-location") {
            this.search.setDistance(null);
            this.search.setRefineLocation(null);
            this.search.setLatLng(null, null);
            this.search.setSort("ascending");
        }
        else {
            this.search.toggleFacet(this.field, this.value);
        }
        this.search.refresh();
    };
    /**
     * @return {?}
     */
    ActiveFacetComponent.prototype.isLocked = /**
     * @return {?}
     */
    function () {
        return this.locked;
    };
    ActiveFacetComponent.decorators = [
        { type: Component, args: [{
                    selector: 'wfbhsearch-active-facet',
                    template: "<div class=\"active-facet\">{{ label }} <a *ngIf=\"!isLocked()\" (click)=\"removeClick()\"\n        attr.aria-label=\"Remove facet {{ label }}\"><span class=\"fa fa-times\"></span></a></div>",
                    styles: [":host{display:inline-block;background:#fff;border:1px solid #e9e9e9;color:#3d3d3d;box-shadow:inset 1px 1px 2px 0 rgba(0,0,0,.2);font-size:10px;border-radius:3px;padding:4px 9px;margin-right:4px;margin-bottom:4px}:host a{color:#3d3d3d;cursor:pointer;margin-left:6px}@media all and (min-width:768px){:host{font-size:12px;border-radius:4px;padding:10px 13px;margin-right:8px}}"]
                }] }
    ];
    /** @nocollapse */
    ActiveFacetComponent.ctorParameters = function () { return [
        { type: SearchService }
    ]; };
    ActiveFacetComponent.propDecorators = {
        locked: [{ type: Input }],
        label: [{ type: Input }],
        field: [{ type: Input }],
        value: [{ type: Input }]
    };
    return ActiveFacetComponent;
}());
if (false) {
    /** @type {?} */
    ActiveFacetComponent.prototype.locked;
    /** @type {?} */
    ActiveFacetComponent.prototype.label;
    /** @type {?} */
    ActiveFacetComponent.prototype.field;
    /** @type {?} */
    ActiveFacetComponent.prototype.value;
    /**
     * @type {?}
     * @private
     */
    ActiveFacetComponent.prototype.search;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ActiveFacet() { }
if (false) {
    /** @type {?} */
    ActiveFacet.prototype.field;
    /** @type {?} */
    ActiveFacet.prototype.label;
    /** @type {?} */
    ActiveFacet.prototype.value;
}
var ActiveFacetsComponent = /** @class */ (function () {
    function ActiveFacetsComponent(search) {
        this.search = search;
    }
    /**
     * @return {?}
     */
    ActiveFacetsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.search.searchStateChanged.subscribe((/**
         * @param {?} results
         * @return {?}
         */
        function (results) {
            _this.facetsList = _this.getFacets();
            _this.lockFacet = results.lockFacet;
            if (_this.search.hasLatLng()) {
                if (_this.search.getSearchState().refineLocation) {
                    _this.facetsList.push({ field: "proxy-location", label: _this.search.getSearchState().refineLocation, value: "Location" });
                }
                else {
                    _this.facetsList.push({ field: "proxy-location", label: "Selected Location", value: "Location" });
                }
            }
            if (_this.search.getDistance()) {
                _this.facetsList.push({ field: "proxy-distance", label: "Within " + _this.search.getDistance() + "  Miles", value: "Distance" });
            }
        }));
    };
    /**
     * @return {?}
     */
    ActiveFacetsComponent.prototype.getFacets = /**
     * @return {?}
     */
    function () {
        var e_1, _a;
        /** @type {?} */
        var ret = [];
        /** @type {?} */
        var facets = this.search.getSearchState().facets;
        /** @type {?} */
        var facetOptions = this.search.facetOptions;
        for (var f in facets) {
            if (facets.hasOwnProperty(f)) {
                /** @type {?} */
                var thisOne = facets[f];
                try {
                    for (var _b = __values(Array.from(thisOne.selectedValues)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var v = _c.value;
                        ret.push({
                            field: thisOne.field,
                            label: facetOptions[thisOne.field].isBool ? facetOptions[thisOne.field].title : v,
                            value: v
                        });
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        }
        return ret;
    };
    /**
     * @return {?}
     */
    ActiveFacetsComponent.prototype.clearFacets = /**
     * @return {?}
     */
    function () {
        this.search.resetFacets();
        this.search.refresh();
    };
    /**
     * @return {?}
     */
    ActiveFacetsComponent.prototype.hasUnlockedFacet = /**
     * @return {?}
     */
    function () {
        return this.search.hasUnlockedFacet() || this.search.hasLatLng() || this.search.getDistance();
    };
    ActiveFacetsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'wfbhsearch-active-facets',
                    template: "<div class=\"active-facets\" *ngIf=\"facetsList.length\">\n    <wfbhsearch-active-facet *ngFor=\"let facet of facetsList\" [field]=\"facet.field\" [value]=\"facet.value\"\n        [label]=\"facet.label\" [locked]=\"lockFacet && lockFacet == facet.field + '|' + facet.value\">\n    </wfbhsearch-active-facet>\n    <a *ngIf=\"hasUnlockedFacet()\" (click)=\"clearFacets()\" class=\"clear-facets-link\">Clear filters</a>\n</div>",
                    styles: [".clear-facets-link{vertical-align:middle;cursor:pointer;font:bold 10px/28px \"Avenir LT W01_85 Heavy1475544\",Arial,sans-serif}@media all and (min-width:768px){.clear-facets-link{font:bold 11px/36px \"Avenir LT W01_85 Heavy1475544\",Arial,sans-serif}}"]
                }] }
    ];
    /** @nocollapse */
    ActiveFacetsComponent.ctorParameters = function () { return [
        { type: SearchService }
    ]; };
    return ActiveFacetsComponent;
}());
if (false) {
    /** @type {?} */
    ActiveFacetsComponent.prototype.lockFacet;
    /** @type {?} */
    ActiveFacetsComponent.prototype.facetsList;
    /** @type {?} */
    ActiveFacetsComponent.prototype.search;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FacetComponent = /** @class */ (function () {
    function FacetComponent(search, dialog, analytics) {
        this.search = search;
        this.dialog = dialog;
        this.analytics = analytics;
        this.isSelected = false;
        this.limitOptions = true;
        this.refineValue = "";
    }
    /**
     * @return {?}
     */
    FacetComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.dialog.closed$.subscribe((/**
         * @param {?} ref
         * @return {?}
         */
        function (ref) { return _this.isSelected = false; }));
    };
    /**
     * @param {?} value
     * @return {?}
     */
    FacetComponent.prototype.isFacetSelected = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return this.search.isFacetSelected(this.facet.field, value.lookupValue);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    FacetComponent.prototype.facetClick = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.search.toggleFacet(this.facet.field, value.lookupValue);
        if (this.isFacetSelected(value)) {
            this.analytics.selectFacetValue(value, this.facet);
        }
        else {
            this.analytics.unselectFacetValue(value, this.facet);
        }
        this.search.refresh();
    };
    /**
     * @return {?}
     */
    FacetComponent.prototype.isVisible = /**
     * @return {?}
     */
    function () {
        return this.facet.currentOptions.length > 1 || this.search.isAnyFacetSelected(this.facet.field);
    };
    /**
     * @return {?}
     */
    FacetComponent.prototype.getDisplayedFacetOptions = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.facet.isBool) {
            for (var i = 0; i < this.facet.currentOptions.length; i++) {
                if (this.facet.currentOptions[i].lookupValue === "true") {
                    /** @type {?} */
                    var trueOption = this.facet.currentOptions[i];
                    trueOption.value = "Yes";
                    return [trueOption];
                }
            }
        }
        if (this.limitOptions == false && this.isSelected == true) {
            /** @type {?} */
            var sorted = this.facet.currentOptions.concat();
            sorted.sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function (a, b) { return _this.sortTitleAlpha(a, b); }));
            if (this.lockFacet) {
                sorted.sort((/**
                 * @param {?} a
                 * @param {?} b
                 * @return {?}
                 */
                function (a, b) { return _this.sortLocked(a, b); }));
            }
            return this.refineOptions(sorted); // return the clone
        }
        if (this.lockFacet) {
            this.facet.currentOptions.sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            function (a, b) { return _this.sortLocked(a, b); }));
        }
        /** @type {?} */
        var options = this.facet.currentOptions;
        // if (this.refineValue.length > 0) {
        //   options = this.refineOptions(options);
        // }
        options = this.limitOptions ? options.slice(0, 5) : options;
        return options;
    };
    /**
     * @param {?} options
     * @return {?}
     */
    FacetComponent.prototype.refineOptions = /**
     * @param {?} options
     * @return {?}
     */
    function (options) {
        /** @type {?} */
        var refinedOptions = [];
        for (var i = 0; i < options.length; i++) {
            if (options[i].value.toLowerCase().indexOf(this.refineValue.toLowerCase()) !== -1) {
                refinedOptions.push(options[i]);
            }
        }
        return refinedOptions;
    };
    /**
     * @param {?} a
     * @param {?} b
     * @param {?=} asc
     * @return {?}
     */
    FacetComponent.prototype.sortLocked = /**
     * @param {?} a
     * @param {?} b
     * @param {?=} asc
     * @return {?}
     */
    function (a, b, asc) {
        if (asc === void 0) { asc = true; }
        if (this.lockFacet == this.facet.field + "|" + a.lookupValue) {
            return asc ? -1 : 1;
        }
        if (this.lockFacet == this.facet.field + "|" + b.lookupValue) {
            return asc ? 1 : -1;
        }
        return 0;
    };
    /**
     * @param {?} a
     * @param {?} b
     * @param {?=} asc
     * @return {?}
     */
    FacetComponent.prototype.sortTitleAlpha = /**
     * @param {?} a
     * @param {?} b
     * @param {?=} asc
     * @return {?}
     */
    function (a, b, asc) {
        if (asc === void 0) { asc = true; }
        if (a.value < b.value) {
            return asc ? -1 : 1;
        }
        if (a.value > b.value) {
            return asc ? 1 : -1;
        }
        return 0;
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    FacetComponent.prototype.facetTitleSelect = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.limitOptions = false;
        this.isSelected = true;
        document.getElementById('main-content').classList.remove("main-content");
        document.getElementsByTagName("body")[0].setAttribute('style', "overflow: hidden;");
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    FacetComponent.prototype.facetBack = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.limitOptions = true;
        this.isSelected = false;
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    FacetComponent.prototype.facetDialogClose = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.dialog.close();
        this.limitOptions = true;
        this.isSelected = false;
        document.getElementById('main-content').classList.add("main-content");
        document.getElementsByTagName("body")[0].setAttribute('style', "");
    };
    /**
     * @param {?} value
     * @return {?}
     */
    FacetComponent.prototype.isLocked = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return this.lockFacet && this.lockFacet === this.facet.field + "|" + value.lookupValue;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FacetComponent.prototype.handleRefineFacetKeyup = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        /** @type {?} */
        var input = (/** @type {?} */ (event.srcElement));
        this.refineValue = input.value;
    };
    FacetComponent.decorators = [
        { type: Component, args: [{
                    selector: 'wfbhsearch-facet',
                    template: "<div cdkTrapFocus [cdkTrapFocus]=\"isSelected\" *ngIf=\"isVisible()\" class=\"facet-group\" [ngClass]=\"{show: isSelected }\">\n  <h4 class=\"facet-title\"><a (click)=\"facetTitleSelect($event)\" class=\"dialog-title-link\">{{ facet.title }}</a>\n    <a class=\"dialog-back\" (click)=\"facetBack($event)\"><span class=\"sr-only\">Go back</span> \u276E </a>\n    <a class=\"dialog-close\" (click)=\"facetDialogClose($event)\">\n      <span class=\"sr-only\">Close {{ facet.title }} options</span> <i class=\"fa fa-remove\"></i>\n    </a>\n  </h4>\n  <div *ngIf=\"isSelected && !facet.isBool\" class=\"form-group form-group-refine-facets\">\n    <label for=\"refineFacets\" class=\"sr-only\">Filter Options</label>\n    <input class=\"form-control\" name=\"refineFacets\" placeholder=\"Search for an option\"\n      (keyup)=\"handleRefineFacetKeyup($event)\" />\n  </div>\n\n  <div class=\"facet-options\">\n    <div *ngIf=\"getDisplayedFacetOptions().length > 0\">\n      <div *ngFor=\"let s of getDisplayedFacetOptions()\" class=\"checkbox\">\n        <label>\n          <input [disabled]=\"isLocked(s)\" type=\"checkbox\" [checked]=\"isFacetSelected(s)\" name=\"filter_{{s.field}}\"\n            (click)=\"facetClick(s);\" value=\"{{ s.lookupValue }}\"> {{ s.value }} <small\n            class=\"text-muted\">({{ s.numberOfResults }})</small>\n        </label>\n      </div>\n    </div>\n    <div *ngIf=\"getDisplayedFacetOptions().length == 0\">\n      <label>No options match filter</label>\n    </div>\n  </div>\n  <a (click)=\"facetTitleSelect($event)\" *ngIf=\"limitOptions && facet.currentOptions.length > 5\" class=\"see-all-facets\">+\n    See all {{ facet.title }}\n    options\n  </a>\n</div>\n<div *ngIf=\"isSelected\" class=\"dialog-backdrop\"></div>",
                    styles: ["@charset \"UTF-8\";@media all and (max-width:1023px){.facet-group.show{position:fixed;top:0;left:0;width:100%;height:100%;overflow:auto;padding:51px 15px 115px;background:#fff;z-index:100}.facet-options{display:none}.show>.facet-options{display:block}}@media all and (min-width:1024px){.facet-group h4{margin:20px 0 4px}.facet-group.show{position:fixed;width:480px;left:50%;top:10%;margin-left:-240px;background:#fff;margin-top:65px;z-index:999;padding:10px 40px;max-height:80vh;height:auto;overflow:auto}}.facet-title{font-size:14px;margin:20px 0 4px;cursor:pointer}.facet-title .dialog-back,.facet-title .dialog-close{display:none}.facet-title a{color:#333;text-decoration:none}@media all and (max-width:1023px){.facet-title{position:relative;margin:0;font:16px/1.4 \"Avenir LT W01_35 Light1475496\",Arial,sans-serif}.facet-title,.facet-title a{color:#333;text-decoration:none;display:block}.facet-title .dialog-title-link{margin-left:-15px;margin-right:-15px;padding:10px 15px;cursor:pointer}.facet-title:after{content:\" \u276F \";position:absolute;right:15px;top:10px}.show>.facet-title{top:0;left:0;width:100%;background:#fff;text-align:center;border-bottom:1px solid #e9e9e9;z-index:1;font:bold 15px/1.4 \"Avenir LT W01_85 Heavy1475544\",Arial,sans-serif}.show>.facet-title a{color:#333}.show>.facet-title .dialog-title-link{padding:15px;display:block;margin:0}.show>.facet-title .dialog-close{display:block;position:absolute;cursor:pointer;right:0;top:0;width:42px;line-height:51px}.show>.facet-title .dialog-back{display:block;position:absolute;cursor:pointer;left:0;top:0;width:42px;line-height:51px}.show>.facet-title:after{display:none}}.show>.facet-title{margin-top:0;margin-bottom:0;position:fixed}@media all and (min-width:1024px){.show>.facet-title{position:fixed;width:480px;top:10%;left:50%;margin:0 0 0 -240px;z-index:1;text-align:left;background:#fff;font:bold 26px/36px \"Avenir LT W01_85 Heavy1475544\",Arial,sans-serif;padding:14px 40px;border-bottom:1px solid #e9e9e9}.show>.facet-title .dialog-close{display:block;position:absolute;cursor:pointer;right:0;top:0;width:42px;font-size:18px;line-height:66px}}label{font-size:.8em}label small{font-size:75%}.checkbox{padding-left:0}.dialog-backdrop{content:\" \";position:fixed;top:0;left:0;width:100%;height:100%;z-index:10;background:rgba(0,0,0,.75)}.see-all-facets{font:bold 13px/1.4 \"Avenir LT W01_85 Heavy1475544\",Arial,sans-serif;display:block;cursor:pointer}@media all and (max-width:1023px){label{font-size:16px;padding-top:4px;padding-bottom:4px}.see-all-facets{display:none}}"]
                }] }
    ];
    /** @nocollapse */
    FacetComponent.ctorParameters = function () { return [
        { type: SearchService },
        { type: DialogService$1 },
        { type: CoveoAnalyticsService }
    ]; };
    FacetComponent.propDecorators = {
        lockFacet: [{ type: Input }],
        facet: [{ type: Input }]
    };
    return FacetComponent;
}());
if (false) {
    /** @type {?} */
    FacetComponent.prototype.lockFacet;
    /** @type {?} */
    FacetComponent.prototype.facet;
    /** @type {?} */
    FacetComponent.prototype.searchState$;
    /** @type {?} */
    FacetComponent.prototype.isSelected;
    /** @type {?} */
    FacetComponent.prototype.limitOptions;
    /** @type {?} */
    FacetComponent.prototype.refineValue;
    /**
     * @type {?}
     * @private
     */
    FacetComponent.prototype.search;
    /**
     * @type {?}
     * @private
     */
    FacetComponent.prototype.dialog;
    /**
     * @type {?}
     * @private
     */
    FacetComponent.prototype.analytics;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FacetsComponent = /** @class */ (function () {
    function FacetsComponent(search, dialog, zone, analytics) {
        this.search = search;
        this.dialog = dialog;
        this.zone = zone;
        this.analytics = analytics;
        this.showFacets = false;
        this.facetsHidden = new EventEmitter();
        this.distance = '';
        this.placesOptions = new Options({
            types: ['geocode'],
            componentRestrictions: { country: 'US' }
        });
        this.locationOptionsVisible = false;
        this.locationLookupLoading = false;
    }
    /**
     * @return {?}
     */
    FacetsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.facetOptions = [];
        for (var key in this.search.facetOptions) {
            this.facetOptions.push(this.search.facetOptions[key]);
        }
        this.dialog.closed$.subscribe((/**
         * @param {?} ref
         * @return {?}
         */
        function (ref) { return _this.locationOptionsVisible = false; }));
        this.search.searchStateChanged.subscribe((/**
         * @param {?} state
         * @return {?}
         */
        function (state) {
            _this.state = state;
            if (_this.state.refineLocation) {
                _this.refineLocation = _this.state.refineLocation;
            }
            else {
                _this.refineLocation = null;
            }
            if (!_this.state.distance) {
                _this.distance = '';
            }
        }));
    };
    /**
     * @return {?}
     */
    FacetsComponent.prototype.getFacetOptions = /**
     * @return {?}
     */
    function () {
        return this.facetOptions;
    };
    /**
     * @return {?}
     */
    FacetsComponent.prototype.resetFacets = /**
     * @return {?}
     */
    function () {
        this.search.resetFacets();
        this.search.refresh();
    };
    /**
     * @return {?}
     */
    FacetsComponent.prototype.hasGeolocation = /**
     * @return {?}
     */
    function () {
        return "geolocation" in navigator;
    };
    /**
     * @param {?} address
     * @return {?}
     */
    FacetsComponent.prototype.handleAddressChange = /**
     * @param {?} address
     * @return {?}
     */
    function (address) {
        /** @type {?} */
        var lat = address.geometry.location.lat();
        /** @type {?} */
        var lng = address.geometry.location.lng();
        this.search.setRefineLocation(address.formatted_address);
        this.search.setLatLng(lat, lng);
        this.search.setSort('distance');
        this.search.setPage(0);
        this.search.refresh();
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    FacetsComponent.prototype.useMyLocationClick = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        var _this = this;
        this.locationLookupLoading = true;
        navigator.geolocation.getCurrentPosition((/**
         * @param {?} position
         * @return {?}
         */
        function (position) {
            _this.search.setSort('distance');
            _this.search.setRefineLocation("(My current location)");
            _this.search.setLatLng(position.coords.latitude, position.coords.longitude);
            _this.search.setPage(0);
            _this.search.refresh();
            _this.locationLookupLoading = false;
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            alert('Your current location is unavailable. Please confirm your browser allows access to your location for this website.');
            _this.locationLookupLoading = false;
        }));
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    FacetsComponent.prototype.distanceChanged = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.search.setDistance(parseInt(this.distance));
        this.search.setSort('distance');
        this.search.setPage(0);
        this.search.refresh();
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    FacetsComponent.prototype.facetDialogClose = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.showFacets = false;
        this.dialog.close();
        this.facetsHidden.emit();
        document.getElementById('main-content').classList.add("main-content");
        document.getElementsByTagName("body")[0].setAttribute('style', "");
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    FacetsComponent.prototype.showLocationOptions = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.locationOptionsVisible = true;
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    FacetsComponent.prototype.locationsBack = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.locationOptionsVisible = false;
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    FacetsComponent.prototype.clearFacets = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.search.resetFacets();
        this.search.refresh();
        this.analytics.clearFacets();
    };
    /**
     * @param {?} sort
     * @return {?}
     */
    FacetsComponent.prototype.sortChange = /**
     * @param {?} sort
     * @return {?}
     */
    function (sort) {
        this.search.setSort(sort);
        this.search.refresh();
    };
    /**
     * @return {?}
     */
    FacetsComponent.prototype.hasDistanceSort = /**
     * @return {?}
     */
    function () {
        return this.state.lat && this.state.lng;
    };
    /**
     * @return {?}
     */
    FacetsComponent.prototype.resetSearch = /**
     * @return {?}
     */
    function () {
        this.search.resetSearch();
        this.analytics.searchBoxClear();
    };
    /**
     * @return {?}
     */
    FacetsComponent.prototype.hasUnlockedFacet = /**
     * @return {?}
     */
    function () {
        return this.search.hasUnlockedFacet();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    FacetsComponent.prototype.handleLocationKeyup = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        var _this = this;
        if (event.key == "Enter") {
            this.locationOptionsVisible = false;
            /** @type {?} */
            var geocoder = new google.maps.Geocoder();
            /** @type {?} */
            var input = (/** @type {?} */ (event.srcElement));
            geocoder.geocode({ address: input.value }, (/**
             * @param {?} results
             * @param {?} status
             * @return {?}
             */
            function (results, status) {
                _this.zone.run((/**
                 * @return {?}
                 */
                function () {
                    if (status == google.maps.GeocoderStatus.OK) {
                        _this.search.setSort('distance');
                        _this.search.setRefineLocation(results[0].formatted_address);
                        _this.search.setLatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                        _this.search.setPage(0);
                        _this.search.refresh();
                    }
                }));
            }));
        }
    };
    FacetsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'wfbhsearch-facets',
                    template: "<div class=\"facets\" [ngClass]=\"{show: showFacets }\">\n    <h3 class=\"dialog-title\"><span class=\"dialog-title-link\">Filter &amp; Sort</span>\n        <a class=\"dialog-close\" (click)=\"facetDialogClose($event)\">\n            <span class=\"sr-only\">Close Dialog</span> <i class=\"fa fa-remove\"></i>\n        </a>\n    </h3>\n    <div class=\"facets-content\">\n        <h3 class=\"facets-title-main\">Refine Results</h3>\n        <div class=\"mobile-sort\">\n            <a class=\"mobile-sort-op\" [ngClass]=\"{active: state.sort == 'ascending'}\"\n                (click)=\"sortChange('ascending')\">Sort\n                by A-Z</a>\n            <a class=\"mobile-sort-op\" [ngClass]=\"{active: state.sort == 'descending'}\"\n                (click)=\"sortChange('descending')\">Sort\n                by Z-A</a>\n            <a class=\"mobile-sort-op\" *ngIf=\"hasDistanceSort()\" [ngClass]=\"{active: state.sort == 'distance'}\"\n                (click)=\"sortChange('distance')\">Sort by Distance</a>\n        </div>\n        <div cdkTrapFocus [cdkTrapFocus]=\"locationOptionsVisible\" class=\"facet-group facet-group-location\"\n            [ngClass]=\"{show: locationOptionsVisible}\">\n            <h4 class=\"facet-title\">\n                <a (click)=\"showLocationOptions($event)\" class=\"dialog-title-link\">Providers Near</a>\n                <a class=\"dialog-back\" (click)=\"locationsBack($event)\"><span class=\"sr-only\">Go back</span> \u276E </a>\n                <a class=\"dialog-close\" (click)=\"facetDialogClose($event)\">\n                    <span class=\"sr-only\">Close Location options</span> <i class=\"fa fa-remove\"></i>\n                </a>\n            </h4>\n            <div class=\"facet-group-location-content\">\n                <div class=\"form-group form-group-location\">\n                    <label for=\"refineLocation\" class=\"sr-only\">Choose a location</label>\n                    <input ngx-google-places-autocomplete [(ngModel)]=\"refineLocation\" name=\"refineLocation\"\n                        [options]='placesOptions' placeholder=\"Address, city or zip\" class=\"form-control\"\n                        #placesRef=\"ngx-places\" (onAddressChange)=\"handleAddressChange($event)\"\n                        (keyup)=\"handleLocationKeyup($event)\" />\n                    <i class=\"fa fa-map-marker\"></i>\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"distance\" class=\"sr-only\">Within distance</label>\n                    <select name=\"distance\" [(ngModel)]=\"distance\" (change)=\"distanceChanged($event)\"\n                        class=\"form-control\">\n                        <option value=\"\">Within any distance</option>\n                        <option value=\"5\">5 miles</option>\n                        <option value=\"10\">10 miles</option>\n                        <option value=\"15\">15 miles</option>\n                        <option value=\"25\">25 miles</option>\n                        <option value=\"50\">50 miles</option>\n                    </select>\n                </div>\n                <a *ngIf=\"hasGeolocation()\" (click)=\"useMyLocationClick($event)\" class=\"use-my-location\"><i\n                        class=\"fa fa-map-marker\"></i> Use my current\n                    location <i *ngIf=\"locationLookupLoading\" class=\"fa fa-circle-o-notch fa-spin\"></i></a>\n            </div>\n        </div>\n        <wfbhsearch-facet *ngFor=\"let option of this.getFacetOptions()\" [facet]=\"option\" [lockFacet]=\"lockFacet\">\n        </wfbhsearch-facet>\n    </div>\n    <div class=\"dialog-footer\">\n        <a class=\"btn bordered show-results\" (click)=\"facetDialogClose($event)\">Show Results</a>\n        <div class=\"row\">\n            <div class=\"col-xs-8\">\n                <a *ngIf=\"hasUnlockedFacet()\" (click)=\"clearFacets($event)\" class=\"clear-facets-link\">Clear filters</a>\n                <a (click)=\"resetSearch()\" class=\"clear-facets-link\">Reset search</a>\n            </div>\n            <div class=\"col-xs-4\">\n                <wfbhsearch-search-info>\n                </wfbhsearch-search-info>\n            </div>\n        </div>\n    </div>\n</div>",
                    styles: ["@charset \"UTF-8\";.facets-title-main{font:bold 18px/1.4 \"Avenir LT W01_35 Light1475496\",Arial,sans-serif;margin-top:0;margin-bottom:24px}.facet-title{font-size:14px;margin:20px 0 4px}.facet-title .dialog-back,.facet-title .dialog-close{display:none}.facet-title a{color:#333;text-decoration:none}@media all and (max-width:1023px){.facets-title-main{display:none}.facet-title{position:relative;margin:0;font:16px/1.4 \"Avenir LT W01_35 Light1475496\",Arial,sans-serif}.facet-title,.facet-title a{color:#333;text-decoration:none;display:block}.facet-title .dialog-title-link{margin-left:-15px;margin-right:-15px;padding:10px 15px;cursor:pointer}.facet-title:after{content:\" \u276F \";position:absolute;right:15px;top:10px}.facets-content{padding:10px 0}}.facets-content{margin-bottom:46px}@media all and (max-width:1023px){.facet-group-location.show{position:fixed;top:0;left:0;width:100%;height:100%;overflow:auto;padding:51px 15px 115px;background:#fff;z-index:100}}@media all and (min-width:1024px){.facet-group-location.show{position:fixed;width:480px;left:50%;top:10%;margin-left:-240px;background:#fff;margin-top:65px;z-index:999;padding:10px 40px;max-height:80vh;height:auto;overflow:auto}}.show>.facet-title{margin-top:0;margin-bottom:0;position:fixed}@media all and (max-width:1023px){.show>.facet-title{top:0;left:0;width:100%;background:#fff;text-align:center;border-bottom:1px solid #e9e9e9;z-index:1;font:bold 15px/1.4 \"Avenir LT W01_85 Heavy1475544\",Arial,sans-serif}.show>.facet-title a{color:#333}.show>.facet-title .dialog-title-link{padding:15px;display:block;margin:0}.show>.facet-title .dialog-close{display:block;position:absolute;cursor:pointer;right:0;top:0;width:42px;line-height:51px}.show>.facet-title .dialog-back{display:block;position:absolute;cursor:pointer;left:0;top:0;width:42px;line-height:51px}.facet-group-location-content,.show>.facet-title:after{display:none}.show>.facet-group-location-content{display:block}}@media all and (min-width:1024px){.show>.facet-title{position:fixed;width:480px;top:10%;left:50%;margin:0 0 0 -240px;z-index:1;text-align:left;background:#fff;font:bold 26px/36px \"Avenir LT W01_85 Heavy1475544\",Arial,sans-serif;padding:14px 40px;border-bottom:1px solid #e9e9e9}.show>.facet-title .dialog-close{display:block;position:absolute;cursor:pointer;right:0;top:0;width:42px;font-size:18px;line-height:66px}}.facet-group-location-content .form-group{margin-bottom:4px}.facet-group-location-content .form-control{font-size:16px}.facet-group-location-content select{margin-bottom:4px}.use-my-location{font:bold 11px/1.4 \"Avenir LT W01_85 Heavy1475544\",Arial,sans-serif;cursor:pointer;display:block;margin-bottom:4px}.form-group-location{position:relative}.form-group-location .fa{position:absolute;top:8px;right:8px}.facets{display:none}@media all and (max-width:1023px){.facet-group-location-content{padding-top:10px}.facet-group-location-content .form-group{margin-bottom:8px}.facets.show{position:fixed;top:0;left:0;width:100%;height:100%;overflow:auto;padding:51px 15px 115px;background:#fff;z-index:99}}@media all and (min-width:1024px){.facets.show{position:fixed;width:480px;left:50%;top:10%;margin-left:-240px;background:#fff;margin-top:65px;z-index:999;padding:10px 40px;max-height:80vh;height:auto;overflow:auto}.facets{display:block}}.dialog-title{margin-top:0;margin-bottom:0;position:fixed}@media all and (max-width:1023px){.dialog-title{top:0;left:0;width:100%;background:#fff;text-align:center;border-bottom:1px solid #e9e9e9;z-index:1;font:bold 15px/1.4 \"Avenir LT W01_85 Heavy1475544\",Arial,sans-serif}.dialog-title a{color:#333}.dialog-title .dialog-title-link{padding:15px;display:block;margin:0}.dialog-title .dialog-close{display:block;position:absolute;cursor:pointer;right:0;top:0;width:42px;line-height:51px}.dialog-title .dialog-back{display:block;position:absolute;cursor:pointer;left:0;top:0;width:42px;line-height:51px}.dialog-title:after{display:none}}@media all and (min-width:1024px){.dialog-title{position:fixed;width:480px;top:10%;left:50%;margin:0 0 0 -240px;z-index:1;text-align:left;background:#fff;font:bold 26px/36px \"Avenir LT W01_85 Heavy1475544\",Arial,sans-serif;padding:14px 40px;border-bottom:1px solid #e9e9e9}.dialog-title .dialog-close{display:block;position:absolute;cursor:pointer;right:0;top:0;width:42px;font-size:18px;line-height:66px}.dialog-footer,.dialog-title{display:none}}.dialog-footer{position:fixed;background:#fff;bottom:0;padding:15px;left:0;width:100%;border-top:1px solid #e9e9e9;z-index:999}.dialog-footer .btn{padding:12px 20px!important;font-size:14px;margin-bottom:10px;font-family:\"Avenir LT W01_85 Heavy1475544\",Arial,sans-serif;font-weight:700}.dialog-footer .clear-facets-link{font:bold 13px/1.4 \"Avenir LT W01_85 Heavy1475544\",Arial,sans-serif;display:inline-block;margin-right:4px;cursor:pointer}.dialog-footer .clear-facets-link+.clear-facets-link{margin-right:0}.dialog-footer .clear-facets-link+.clear-facets-link:before{content:\"|\";margin:0 4px 0 0}.mobile-sort{padding:5px 15px 15px;margin-left:-15px;margin-right:-15px;border-bottom:1px solid #e9e9e9}.mobile-sort a{display:inline-block;border:1px solid #e9e9e9;padding:4px 10px;margin-right:10px;font-size:11px;text-decoration:none;cursor:pointer}.mobile-sort a:focus,.mobile-sort a:hover{border-color:#00806f}.mobile-sort a.active{color:#fff;background:#00806f;border-color:#00806f}@media all and (min-width:1024px){.mobile-sort{display:none}}select{-webkit-appearance:menulist;-moz-appearance:menulist}"]
                }] }
    ];
    /** @nocollapse */
    FacetsComponent.ctorParameters = function () { return [
        { type: SearchService },
        { type: DialogService },
        { type: NgZone },
        { type: CoveoAnalyticsService }
    ]; };
    FacetsComponent.propDecorators = {
        showFacets: [{ type: Input }],
        facetsHidden: [{ type: Output }],
        lockFacet: [{ type: Input }]
    };
    return FacetsComponent;
}());
if (false) {
    /** @type {?} */
    FacetsComponent.prototype.showFacets;
    /** @type {?} */
    FacetsComponent.prototype.facetsHidden;
    /** @type {?} */
    FacetsComponent.prototype.lockFacet;
    /** @type {?} */
    FacetsComponent.prototype.facetOptions;
    /** @type {?} */
    FacetsComponent.prototype.distance;
    /** @type {?} */
    FacetsComponent.prototype.placesOptions;
    /** @type {?} */
    FacetsComponent.prototype.refineLocation;
    /** @type {?} */
    FacetsComponent.prototype.state;
    /** @type {?} */
    FacetsComponent.prototype.locationOptionsVisible;
    /** @type {?} */
    FacetsComponent.prototype.locationLookupLoading;
    /** @type {?} */
    FacetsComponent.prototype.search;
    /**
     * @type {?}
     * @private
     */
    FacetsComponent.prototype.dialog;
    /**
     * @type {?}
     * @private
     */
    FacetsComponent.prototype.zone;
    /**
     * @type {?}
     * @private
     */
    FacetsComponent.prototype.analytics;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SearchInfoComponent = /** @class */ (function () {
    function SearchInfoComponent(search) {
        this.search = search;
    }
    /**
     * @return {?}
     */
    SearchInfoComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    SearchInfoComponent.prototype.getCurrentPageCount = /**
     * @return {?}
     */
    function () {
        return Math.min(this.search.getPage() * 25 + 25, this.search.totalResults);
    };
    /**
     * @return {?}
     */
    SearchInfoComponent.prototype.getTotalResults = /**
     * @return {?}
     */
    function () {
        return this.search.totalResults > 1000 ? '1000+' : String(this.search.totalResults);
    };
    SearchInfoComponent.decorators = [
        { type: Component, args: [{
                    selector: 'wfbhsearch-search-info',
                    template: "<div *ngIf=\"search.totalResults > 0 && !search.getQuery()\" class=\"search-info\">Showing {{ search.getPage() * 25 + 1}} -\n    {{ getCurrentPageCount() }}\n    of\n    {{ getTotalResults() }} results.\n</div>\n<div *ngIf=\"search.totalResults > 0 && search.getQuery()\" class=\"search-info\">Showing {{ search.getPage() * 25 + 1}} -\n    {{ getCurrentPageCount() }}\n    of\n    {{ getTotalResults() }} results <span class=\"hidden-xs\">for \"{{ search.getQuery() }}\"</span>\n</div>\n<div *ngIf=\"search.totalResults == 0\" class=\"search-info\">Showing 0 results.</div>",
                    styles: [".search-info{font-size:11px;font-style:italic;text-align:right}@media all and (min-width:768px){.search-info{font-size:13px;margin-bottom:0}}@media all and (min-width:1024px){.search-info{text-align:left}}"]
                }] }
    ];
    /** @nocollapse */
    SearchInfoComponent.ctorParameters = function () { return [
        { type: SearchService }
    ]; };
    return SearchInfoComponent;
}());
if (false) {
    /** @type {?} */
    SearchInfoComponent.prototype.search;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SearchPageComponent = /** @class */ (function () {
    function SearchPageComponent(search, dialog, analytics) {
        this.search = search;
        this.dialog = dialog;
        this.analytics = analytics;
        this.filterSortVisible = false;
    }
    /**
     * @return {?}
     */
    SearchPageComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.search.searchStateChanged.subscribe((/**
         * @param {?} state
         * @return {?}
         */
        function (state) {
            if (state.keywords) {
                _this.keywords = state.keywords;
            }
            else if (state.query) {
                _this.keywords = state.query;
            }
            else {
                _this.keywords = '';
            }
            _this.lockFacet = state.lockFacet;
        }));
        this.dialog.closed$.subscribe((/**
         * @param {?} ref
         * @return {?}
         */
        function (ref) { return _this.filterSortVisible = false; }));
        this.search.initFromUrl();
    };
    /**
     * @return {?}
     */
    SearchPageComponent.prototype.showFilterSort = /**
     * @return {?}
     */
    function () {
        this.filterSortVisible = true;
        this.dialog.open('filterSort');
        document.getElementById('main-content').classList.remove("main-content");
        document.getElementsByTagName("body")[0].setAttribute('style', "overflow: hidden;");
    };
    /**
     * @return {?}
     */
    SearchPageComponent.prototype.onFacetsHidden = /**
     * @return {?}
     */
    function () {
        this.filterSortVisible = false;
        this.dialog.close();
    };
    /**
     * @return {?}
     */
    SearchPageComponent.prototype.resetSearch = /**
     * @return {?}
     */
    function () {
        this.search.resetSearch();
        this.analytics.searchBoxClear();
    };
    /**
     * @return {?}
     */
    SearchPageComponent.prototype.showResults = /**
     * @return {?}
     */
    function () {
        return (typeof this.search.totalResults === "number");
    };
    /**
     * @return {?}
     */
    SearchPageComponent.prototype.showNoResultsOnly = /**
     * @return {?}
     */
    function () {
        return !this.search.hasLatLng() && this.search.totalResults == 0 && (typeof this.search.totalResults === "number");
    };
    SearchPageComponent.decorators = [
        { type: Component, args: [{
                    selector: 'wfbhsearch-search-page',
                    template: "<div class=\"white-bg\">\n  <div *ngIf=\"!search.hidden\" class=\"container banner-search\">\n    <div class=\"provider-phone-numbers hidden-xs hidden-sm\">\n      <a href=\"tel:+13367169253\">336-716-WAKE (9253)</a>\n      <a href=\"tel:+18887169253\">888-716-9253 (toll-free)</a>\n    </div>\n    <h1>Find a Provider</h1>\n    <div class=\"searchbox\">\n      <wfbhsearch-searchbox [keywords]=\"keywords\">\n      </wfbhsearch-searchbox>\n    </div>\n  </div>\n</div>\n<div class=\"container search-page\">\n  <div *ngIf=\"!showNoResultsOnly()\" class=\"row\">\n    <div class=\"col-md-3\">\n      <wfbhsearch-facets [showFacets]=\"filterSortVisible\" [lockFacet]=\"lockFacet\" (facetsHidden)=\"onFacetsHidden()\">\n      </wfbhsearch-facets>\n    </div>\n    <div class=\"col-md-9\">\n      <div class=\"row\">\n        <div class=\"filter-sort col-xs-6\">\n          <a (click)=\"showFilterSort()\" class=\"show-filter-sort\"><i class=\"fa fa-sliders\"></i> Filter &amp; Sort</a>\n        </div>\n        <div class=\"col-xs-6 col-md-12 search-info-container\">\n          <wfbhsearch-search-info>\n          </wfbhsearch-search-info>\n        </div>\n      </div>\n      <div class=\"row\">\n        <div class=\"col-md-9\">\n          <wfbhsearch-active-facets></wfbhsearch-active-facets>\n        </div>\n        <div class=\"col-md-3\">\n          <wfbhsearch-sort [ngClass]=\"{show: filterSortVisible}\">\n          </wfbhsearch-sort>\n        </div>\n      </div>\n      <div *ngIf=\"showResults()\">\n        <wfbhsearch-search-results>\n        </wfbhsearch-search-results>\n      </div>\n    </div>\n  </div>\n\n  <div *ngIf=\"showNoResultsOnly()\" class=\"row\">\n    <div class=\"col-sm-12\">\n      <wfbhsearch-search-results></wfbhsearch-search-results>\n    </div>\n  </div>\n</div>",
                    styles: ["@media all and (min-width:1024px){.banner-search{padding-top:40px}}.searchbox{padding-bottom:15px}.search-page{padding-top:15px}@media all and (min-width:1024px){.search-page{padding-top:46px}}@media all and (max-width:1023px){.search-info-container{text-align:right}}.show-filter-sort{font-size:16px;font-weight:700;font-family:\"Avenir LT W01_85 Heavy1475544\",Arial,sans-serif;padding:5px 0 4px;display:inline-block;cursor:pointer}.show-filter-sort .fa{font-size:1.4em;vertical-align:top;position:relative;top:-2px}@media all and (min-width:1024px){.show-filter-sort{display:none}}.provider-phone-numbers{margin:10px 0;line-height:43px;font-size:16px;float:right}.provider-phone-numbers a{display:inline-block;margin-left:20px}.reset-search{font:bold 12px/1.4 \"Avenir LT W01_85 Heavy1475544\",Arial,sans-serif;display:block;cursor:pointer}@media all and (min-width:768px){.reset-search{font-size:13px}}@media all and (min-width:1024px){app-search-info{float:left}.reset-search{float:right;margin-bottom:4px}}"]
                }] }
    ];
    /** @nocollapse */
    SearchPageComponent.ctorParameters = function () { return [
        { type: SearchService },
        { type: DialogService$1 },
        { type: CoveoAnalyticsService }
    ]; };
    return SearchPageComponent;
}());
if (false) {
    /** @type {?} */
    SearchPageComponent.prototype.searchState$;
    /** @type {?} */
    SearchPageComponent.prototype.searchState;
    /** @type {?} */
    SearchPageComponent.prototype.filterSortVisible;
    /** @type {?} */
    SearchPageComponent.prototype.keywords;
    /** @type {?} */
    SearchPageComponent.prototype.lockFacet;
    /** @type {?} */
    SearchPageComponent.prototype.search;
    /**
     * @type {?}
     * @private
     */
    SearchPageComponent.prototype.dialog;
    /**
     * @type {?}
     * @private
     */
    SearchPageComponent.prototype.analytics;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SearchResultComponent = /** @class */ (function () {
    function SearchResultComponent(analytics) {
        this.analytics = analytics;
        this.showNoRatingDialog = false;
    }
    /**
     * @return {?}
     */
    SearchResultComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    SearchResultComponent.prototype.getRatingPercentage = /**
     * @return {?}
     */
    function () {
        return String((this.result.rating / 5) * 100) + '%';
    };
    /**
     * @return {?}
     */
    SearchResultComponent.prototype.noRatingClick = /**
     * @return {?}
     */
    function () {
        document.getElementById('main-content').classList.remove("main-content");
        document.getElementsByTagName("body")[0].setAttribute('style', "overflow: hidden;");
        this.showNoRatingDialog = true;
    };
    /**
     * @return {?}
     */
    SearchResultComponent.prototype.noRatingDialogClose = /**
     * @return {?}
     */
    function () {
        this.showNoRatingDialog = false;
        document.getElementById('main-content').classList.add("main-content");
        document.getElementsByTagName("body")[0].setAttribute('style', "");
    };
    /**
     * @return {?}
     */
    SearchResultComponent.prototype.openResult = /**
     * @return {?}
     */
    function () {
        this.analytics.resultClick(this.result);
    };
    SearchResultComponent.decorators = [
        { type: Component, args: [{
                    selector: 'wfbhsearch-search-result',
                    template: "<div class=\"row\">\n  <div class=\"col-md-9\">\n    <h3 class=\"search-result-title\"><a (click)=\"openResult()\">{{ result.title }}</a></h3>\n    <div class=\"row\">\n      <div class=\"col-md-7\">\n        <div class=\"provider-image-mobile\">\n          <a (click)=\"openResult()\"><img class=\"search-result-image\"\n              src=\"https://www.wakehealth.edu/{{ result.image }}\" /></a>\n        </div>\n        <div *ngIf=\"result.specialties?.length\" class=\"search-result-specialties\">\n          <h4 class=\"specialties-title search-result-subtitle\">Specialties</h4>\n          <ul class=\"search-result-specialities\">\n            <li *ngFor=\"let specialty of result.specialties\">\n              {{ specialty }}\n            </li>\n          </ul>\n        </div>\n        <div>{{ result.position }}</div>\n        <div>{{ result.providerType }}</div>\n        <div class=\"search-result-rating\" *ngIf=\"result.showRating && result.totalRatings > 0\">\n          <div class=\"stars-base\">\n            <i class=\"fa fa-star-o\"></i>\n            <i class=\"fa fa-star-o\"></i>\n            <i class=\"fa fa-star-o\"></i>\n            <i class=\"fa fa-star-o\"></i>\n            <i class=\"fa fa-star-o\"></i>\n          </div>\n          <div class=\"stars-value\" [ngStyle]=\"{ 'width': getRatingPercentage() }\">\n            <i class=\"fa fa-star\"></i>\n            <i class=\"fa fa-star\"></i>\n            <i class=\"fa fa-star\"></i>\n            <i class=\"fa fa-star\"></i>\n            <i class=\"fa fa-star\"></i>\n          </div>\n        </div>\n        <a (click)=\"openResult()\" *ngIf=\"result.showRating && result.totalRatings > 0\">{{ result.rating }} ({{ result.totalRatings }} ratings)</a>\n\n        <div *ngIf=\"!result.showRating\">\n          <div class=\"search-result-rating\">\n            <div class=\"stars-base\">\n              <i class=\"fa fa-star-o\"></i>\n              <i class=\"fa fa-star-o\"></i>\n              <i class=\"fa fa-star-o\"></i>\n              <i class=\"fa fa-star-o\"></i>\n              <i class=\"fa fa-star-o\"></i>\n            </div>    \n          </div>\n          <a class=\"no-ratings\" (click)=\"noRatingClick()\">Why no ratings?</a>\n          <div *ngIf=\"showNoRatingDialog\" class=\"dialog-content\">\n            <div class=\"norating-dialog\">\n              <a class=\"dialog-close\" (click)=\"noRatingDialogClose()\">\n                <span class=\"sr-only\">Close no ratings dialog</span> <i class=\"fa fa-remove\"></i>\n              </a>\n              <div class=\"h3\">Why No Ratings</div>\n              <p>Currently, not all doctor ratings and comments are available. The number of rated physicians will increase over time.</p>\n              <p>The more ratings a provider receives, the more accurate and statistically reliable the data is. Providers with less than 30 ratings may not have patient ratings listed on their profiles.</p>\n              <p>To learn more about this survey process, visit our <a href=\"/About-Us/Quality-and-Awards/Quality-and-Safety-Measures/Patient-Experience/About-the-Press-Ganey-Patient-Experience-Survey\">about the survey page</a>.</p>\n            </div>\n          </div>\n        </div>\n        <div *ngIf=\"showNoRatingDialog\" class=\"dialog-backdrop\"></div>\n        <a data-toggle=\"modal\" class=\"insurance-accepted\" data-target=\"#providerInsuranceModal\">Insurance Accepted</a>\n        <div *ngIf=\"result.newpatients === 'true'\" class=\"accepting-new-patients\">Accepting New Patients</div>\n        <div *ngIf=\"result.onlineSchedule === 'true' && result.newpatients === 'true'\" style=\"margin-top: 20px;\" class=\"hidden-xs\">\n          <a class=\"btn schedule-button\" data-toggle=\"modal\" data-target=\"#schedApptOptionsModal\" title=\"Appointments\" [attr.data-pn-name]=\"result.fullName\" [attr.data-pn-id]=\"result.epicId\" [attr.data-m-path]=\"result.messagePath\" [attr.data-pn-ds]=\"result.directSchedule\" [attr.data-pn-ap]=\"result.newpatients\" [attr.data-pn-ep]=\"result.existingpatients\" [attr.data-pn-os]=\"result.onlineSchedule\" [attr.data-pn-vt]=\"(result.visitType ? result.visitType : '1003')\" [attr.data-pn-url]=\"result.uri\">Appointments</a>\n        </div>\n      </div>\n      <div class=\"col-md-5\">\n        <ng-container *ngIf=\"result.locations.length\">\n          <h3 class=\"search-result-locations-title search-result-subtitle\">\n            Locations\n          </h3>\n          <div *ngFor=\"let location of result.locations\" class=\"result-location\">\n            <h4 class=\"location-title\"><a\n                href=\"{{location.pageurl}}\">{{ location.name }}</a></h4>\n            <div>{{ location.address1 }}</div>\n            <div *ngIf=\"location.floorsuite\">{{ location.floorsuite }}</div>\n            <div>{{ location.address2 }}</div>\n            <div *ngIf=\"location.distance\" class=\"location-distance\">Distance from location:\n              {{ (location.distance/1610).toFixed(2) }} miles</div>\n            <div *ngIf=\"location.phone\" class=\"location-phone\"><a\n                href=\"tel:{{ location.phone }}\">{{ location.phone }}</a></div>\n\n          </div>\n        </ng-container>\n        <div *ngIf=\"result.onlineSchedule === 'true' && result.newpatients === 'true'\" style=\"margin-top: 20px;\" class=\"visible-xs-block\">\n          <a class=\"btn schedule-button\" data-toggle=\"modal\" data-target=\"#schedApptOptionsModal\" title=\"Options\" [attr.data-pn-name]=\"result.fullName\" [attr.data-pn-id]=\"result.epicId\" [attr.data-m-path]=\"result.messagePath\" [attr.data-pn-ds]=\"result.directSchedule\" [attr.data-pn-ap]=\"result.newpatients\" [attr.data-pn-ep]=\"result.existingpatients\" [attr.data-pn-os]=\"result.onlineSchedule\" [attr.data-pn-vt]=\"(result.visitType ? result.visitType : '1003')\" [attr.data-pn-url]=\"result.uri\">Appointments</a>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-md-3 text-right provider-image-desktop\">\n    <a (click)=\"openResult()\"><img class=\"search-result-image\"\n        src=\"https://www.wakehealth.edu/{{ result.image }}\" /></a>\n  </div>\n</div>\n\n",
                    styles: ["@charset \"UTF-8\";:host{font-size:14px}a{cursor:pointer}.search-result-title{font:22px/1.4 \"Avenir LT W01_35 Light1475496\",Arial,sans-serif;letter-spacing:-.13px;margin:0}@media all and (min-width:768px){.search-result-title{font:26px/36px \"Avenir LT W01_35 Light1475496\",Arial,sans-serif}}.search-result-subtitle{font:10px/1.4 \"Avenir LT W01_35 Light1475496\",Arial,sans-serif;text-transform:uppercase;letter-spacing:1.95px;margin:14px 0 4px}.search-result-specialties{font-weight:700;font-size:14px;font-family:\"Avenir LT W01_85 Heavy1475544\",Arial,sans-serif;margin-bottom:10px}.search-result-rating{margin-top:10px;position:relative;display:inline-block;width:81px;margin-right:10px}.search-result-rating .fa-star,.search-result-rating .fa-star-o{margin-right:4px;color:#8c6d20}.search-result-rating .fa-star-o:last-child,.search-result-rating .fa-star:last-child{margin-right:0}.search-result-rating .stars-value{position:absolute;top:0;left:0;white-space:nowrap;overflow:hidden}.no-ratings{display:block;cursor:pointer}.search-result-image{max-width:163px;padding:8px;border:1px solid #e9e9e9;margin:0;display:inline-block}.schedule-button{padding:10px 20px!important}.result-location{margin-bottom:20px}.result-location:last-child{margin-bottom:0}.location-title{font-size:16px}.location-distance,.location-phone{margin-top:8px}.provider-image-mobile{display:none}@media all and (max-width:991px){.provider-image-desktop{display:none}.provider-image-mobile{display:block;float:right;width:107px;margin-left:10px;margin-bottom:10px}.provider-image-mobile img{max-width:100%!important}}@media all and (max-width:1023px){.norating-dialog{position:fixed;top:0;left:0;width:100%;height:100%;overflow:auto;padding:51px 15px 115px;background:#fff;z-index:99}}@media all and (min-width:1024px){.norating-dialog{position:fixed;width:480px;left:50%;top:10%;margin-left:-240px;background:#fff;margin-top:65px;z-index:999;padding:10px 40px;max-height:80vh;height:auto;overflow:auto}}.dialog-backdrop{content:\" \";position:fixed;top:0;left:0;width:100%;height:100%;z-index:10;background:rgba(0,0,0,.75)}.dialog-close{display:block;position:absolute;cursor:pointer;right:0;top:0;width:42px;line-height:51px;color:#333}.search-result-specialities{list-style-type:none;margin:0;padding:0}.search-result-specialities li{list-style:none;margin:0}.search-result-specialities li::before{content:none}.insurance-accepted{cursor:pointer;display:block;margin-top:10px}.accepting-new-patients{margin-top:10px}.accepting-new-patients::before{display:inline-block;font:14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;content:\"\uF058\";margin-right:5px;color:#8c6d20}"]
                }] }
    ];
    /** @nocollapse */
    SearchResultComponent.ctorParameters = function () { return [
        { type: CoveoAnalyticsService }
    ]; };
    SearchResultComponent.propDecorators = {
        result: [{ type: Input }]
    };
    return SearchResultComponent;
}());
if (false) {
    /** @type {?} */
    SearchResultComponent.prototype.result;
    /** @type {?} */
    SearchResultComponent.prototype.showNoRatingDialog;
    /**
     * @type {?}
     * @private
     */
    SearchResultComponent.prototype.analytics;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SearchResultsComponent = /** @class */ (function () {
    function SearchResultsComponent(search, analytics) {
        this.search = search;
        this.analytics = analytics;
        this.results = [];
        this.numPages = 0;
        this.pageList = [];
        this.currentPage = 0;
    }
    /**
     * @return {?}
     */
    SearchResultsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.search.resultsUpdated.subscribe((/**
         * @param {?} results
         * @return {?}
         */
        function (results) {
            _this.results = results;
            if (_this.results.length) {
                _this.numPages = Math.ceil(Math.min(1000, _this.search.totalResults) / _this.search.getPageSize());
                _this.currentPage = _this.search.getPage();
                /** @type {?} */
                var firstPage_1 = Math.max(0, _this.currentPage - 5);
                // const lastPage = Math.max(10, currentPage + 5);
                _this.pageList = Array(Math.min(_this.numPages, 10)).fill(null).map((/**
                 * @param {?} x
                 * @param {?} i
                 * @return {?}
                 */
                function (x, i) { return i + firstPage_1; }));
            }
            else {
                _this.numPages = 0;
            }
        }));
    };
    /**
     * @param {?} page
     * @param {?} source
     * @return {?}
     */
    SearchResultsComponent.prototype.selectPage = /**
     * @param {?} page
     * @param {?} source
     * @return {?}
     */
    function (page, source) {
        console.log('Select page: ' + page);
        this.search.setPage(page);
        this.search.getResults().subscribe();
        // back to top
        /** @type {?} */
        var scrollToTop = window.setInterval((/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var pos = window.pageYOffset;
            if (pos > 0) {
                window.scrollTo(0, pos - 1500);
            }
            else {
                window.clearInterval(scrollToTop);
            }
        }), 16);
        this.analytics.goToPage(page, source);
    };
    /**
     * @return {?}
     */
    SearchResultsComponent.prototype.resetSearch = /**
     * @return {?}
     */
    function () {
        this.search.clearCQ();
        this.search.reset();
        this.search.refresh();
    };
    SearchResultsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'wfbhsearch-search-results',
                    template: "<div class=\"no-results-message\" *ngIf=\"!results.length\">\n  <p>We're sorry. No providers found for your search term. Please try a different term.</p>\n  <p>Need help finding a provider? Let us help you find the right one. <a href=\"tel:+13367169253\">336-716-WAKE (9253)</a></p>\n  <p><a class=\"reset-search\" (click)=\"resetSearch()\">Start a new search</a></p>\n</div>\n<ul class=\"search-results-new\">\n  <li *ngFor=\"let result of results\" class=\"search-result-new\">\n    <wfbhsearch-search-result [result]=\"result\">\n    </wfbhsearch-search-result>\n  </li>\n</ul>\n<div class=\"pagination\" *ngIf=\"numPages > 1\">\n  <nav aria-label=\"Search results navigation\">\n    <ul class=\"paginate\">\n      <li *ngIf=\"currentPage > 5\">\n        <a (click)=\"selectPage(0, 'first')\" aria-label=\"First\">\n          <span aria-hidden=\"true\">\u00AB First</span>\n        </a>\n      </li>\n      <li *ngIf=\"currentPage > 1\">\n        <a (click)=\"selectPage(currentPage - 1, 'previous')\" aria-label=\"Previous\">\n          <span aria-hidden=\"true\">\u2039 Previous</span>\n        </a>\n      </li>\n      <li *ngFor=\"let p of pageList\">\n        <a (click)=\"selectPage(p, 'direct')\" [ngClass]=\"{'active': currentPage == p}\">\n          <span aria-hidden=\"true\">{{ p + 1 }}</span>\n        </a>\n      </li>\n      <li *ngIf=\"numPages > currentPage\">\n        <a (click)=\"selectPage(currentPage+1, 'next')\" aria-label=\"Next\">\n          <span aria-hidden=\"true\">Next \u203A</span>\n        </a>\n      </li>\n      <li *ngIf=\"currentPage < (numPages - 5) && numPages > 10\">\n        <a (click)=\"selectPage(numPages-1, 'last')\" aria-label=\"Last\">\n          <span aria-hidden=\"true\">Last \u00BB</span>\n        </a>\n      </li>\n    </ul>\n  </nav>\n</div>",
                    styles: [".paginate a.active{font-weight:700;font-family:\"Avenir LT W01_85 Heavy1475544\",Arial,sans-serif}.paginate a{cursor:pointer}.search-results-new{margin:0}.search-result-new{background:#fff;margin:10px 0;padding:25px;list-style:none}@media all and (minw-width:7689px){.search-result-new{margin:20px 0}}.no-results-message{margin:10px 0 46px}.no-results-message p:last-child{margin-bottom:0}.pagination nav{border-bottom:none}.reset-search{cursor:pointer}"]
                }] }
    ];
    /** @nocollapse */
    SearchResultsComponent.ctorParameters = function () { return [
        { type: SearchService },
        { type: CoveoAnalyticsService }
    ]; };
    return SearchResultsComponent;
}());
if (false) {
    /** @type {?} */
    SearchResultsComponent.prototype.results;
    /** @type {?} */
    SearchResultsComponent.prototype.numPages;
    /** @type {?} */
    SearchResultsComponent.prototype.pageList;
    /** @type {?} */
    SearchResultsComponent.prototype.currentPage;
    /** @type {?} */
    SearchResultsComponent.prototype.totalResults;
    /** @type {?} */
    SearchResultsComponent.prototype.search;
    /**
     * @type {?}
     * @private
     */
    SearchResultsComponent.prototype.analytics;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SuggestResultComponent = /** @class */ (function () {
    function SuggestResultComponent(element) {
        this.element = element;
        this.uri = "";
        this.title = "";
        this.resultSelect = new EventEmitter();
        this._isActive = false;
    }
    Object.defineProperty(SuggestResultComponent.prototype, "isActive", {
        get: /**
         * @return {?}
         */
        function () {
            return this._isActive;
        },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @return {?}
     */
    SuggestResultComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.title = this.title || this.result.title;
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    SuggestResultComponent.prototype.suggestClick = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        if (this.result) {
            $event.preventDefault();
            this.resultSelect.emit(this.result ? this.result : this.uri);
        }
    };
    /**
     * @return {?}
     */
    SuggestResultComponent.prototype.setActiveStyles = /**
     * @return {?}
     */
    function () {
        this._isActive = true;
    };
    ;
    /**
     * @return {?}
     */
    SuggestResultComponent.prototype.setInactiveStyles = /**
     * @return {?}
     */
    function () {
        this._isActive = false;
    };
    /**
     * @return {?}
     */
    SuggestResultComponent.prototype.getLabel = /**
     * @return {?}
     */
    function () {
        return this.result ? this.result.title : '';
    };
    /**
     * @return {?}
     */
    SuggestResultComponent.prototype.selectItem = /**
     * @return {?}
     */
    function () {
        this.resultLink.nativeElement.click();
    };
    SuggestResultComponent.decorators = [
        { type: Component, args: [{
                    host: {
                        'role': 'option'
                    },
                    selector: '[wfbhsearch-suggest-result]',
                    template: "<a #resultLink (click)=\"suggestClick($event);\" href=\"{{ uri }}\">\n    {{title}} <small *ngIf=\"result\" class=\"suggest-meta\">{{ result.type }}</small>\n</a>",
                    styles: [":host{list-style:none!important;margin-bottom:0!important}:host a{display:block;padding:8px 14px}@media all and (min-width:768px){:host a{padding:12px 20px}}:host.active,:host:hover{background:#f5f5f5}:host.active a,:host:hover a{color:#00806f}"]
                }] }
    ];
    /** @nocollapse */
    SuggestResultComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    SuggestResultComponent.propDecorators = {
        result: [{ type: Input }],
        uri: [{ type: Input }],
        title: [{ type: Input }],
        resultSelect: [{ type: Output }],
        resultLink: [{ type: ViewChild, args: ['resultLink', { static: true },] }],
        isActive: [{ type: HostBinding, args: ['class.active',] }]
    };
    return SuggestResultComponent;
}());
if (false) {
    /** @type {?} */
    SuggestResultComponent.prototype.disabled;
    /** @type {?} */
    SuggestResultComponent.prototype.result;
    /** @type {?} */
    SuggestResultComponent.prototype.uri;
    /** @type {?} */
    SuggestResultComponent.prototype.title;
    /** @type {?} */
    SuggestResultComponent.prototype.resultSelect;
    /** @type {?} */
    SuggestResultComponent.prototype.resultLink;
    /**
     * @type {?}
     * @private
     */
    SuggestResultComponent.prototype._isActive;
    /**
     * @type {?}
     * @private
     */
    SuggestResultComponent.prototype.element;
    /* Skipping unhandled member: ;*/
    /* Skipping unhandled member: ;*/
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SearchboxComponent = /** @class */ (function () {
    function SearchboxComponent(search, analytics) {
        this.search = search;
        this.analytics = analytics;
        this.useRouting = true;
        this.searchUrl = '';
        this.keywordsChanged$ = new Subject();
        this.suggest = [];
        this.cancelSuggest = false;
        this.searchOpRunning = false;
        this.showPopular = false;
        this.popularSearches = [
            { title: "Primary Care", uri: '?q=&sort=ascending&l05=@wfsspecialties==("Primary Care","Family Medicine","General Pediatrics","General Internal Medicine")' },
            { title: "Comprehensive Cancer Center", uri: '?facets=@wfslocationname=Comprehensive Cancer Center&sort=ascending&keywords=Comprehensive Cancer Center&lockFacet=@wfslocationname|Comprehensive Cancer Center' },
            { title: "Heart and Vascular", uri: '?q=&sort=ascending&l05=@wfsspecialties==("Interventional Cardiology","Cardiology","Pediatric Cardiology","Electrophysiology","Vascular Medicine","Vascular and Endovascular Surgery","Cardiothoracic Surgery","Pediatric Cardiothoracic Surgery","Advanced Heart Failure and Transplant")' },
            { title: "Neurology and Neurosurgery", uri: '?q=&sort=ascending&l05=@wfsspecialties==("Neurology","Pediatric Neurology","General Neurology","Sleep Medicine","Multiple Sclerosis","Neuromuscular","Stroke","Neurosurgery","Pediatric Neurosurgery","Clinical Neurophysiology","Neuropsychology","Neuro-Critical Care","Neurorehab","Movement Disorders","Headache","Epilepsy")' },
            { title: "Orthopaedics", uri: '?facets=@wfsspecialties=Orthopaedics&sort=ascending&keywords=Orthopaedics&lockFacet=@wfsspecialties|Orthopaedics' },
            { title: "Pediatrics", uri: '?q=&sort=ascending&l05=@wfsspecialties==("Neonatology","Pediatric Hospital Medicine","General Pediatrics","Pediatric Radiology","Pediatric ENT/Head and Neck Surgery","Pediatric Emergency Medicine","Pediatric Intensive Care Unit","Pediatric Medical Genetics","Pediatric Hematology and Oncology","Pediatric Infectious Diseases","Pediatric Allergy and Immunology","Pediatric Nephrology","Pediatric Development and Behavior","Pediatric Endocrinology","Pediatric Neurosurgery","Pediatric Pulmonology","Pediatric Gastroenterology","Pediatric Anesthesiology","Pediatric Surgery","Pediatric Orthopaedics","Child Abuse","Pediatric Neurology","Pediatric Psychiatry","Pediatric Cardiology","Pediatric Cardiothoracic Surgery","Pediatric Psychology","Pediatric Dermatology","Pediatric Audiology","Pediatric Urology","Pediatric Rheumatology")' }
        ];
    }
    /**
     * @return {?}
     */
    SearchboxComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.analytics.interfaceLoad();
        this.search.resultsUpdated.subscribe((/**
         * @param {?} results
         * @return {?}
         */
        function (results) {
            _this.suggest = [];
            _this.showPopular = false;
        }));
        this.search.searchStateChanged.subscribe((/**
         * @param {?} state
         * @return {?}
         */
        function (state) {
            if (state.keywords) {
                _this.keywords = state.keywords;
            }
            else if (state.query) {
                _this.keywords = state.query;
            }
            else {
                _this.keywords = '';
            }
            _this.state = state;
        }));
        this.keywordsChanged$.pipe(debounceTime(200)).subscribe((/**
         * @param {?} keywords
         * @return {?}
         */
        function (keywords) {
            if (keywords.length < 1) {
                _this.suggest = [];
                return;
            }
            if (keywords.length >= 2) {
                _this.search.suggest(keywords).pipe(takeWhile((/**
                 * @return {?}
                 */
                function () {
                    if (_this.cancelSuggest) {
                        _this.cancelSuggest = false;
                        return false;
                    }
                    return true;
                })), take(1)).subscribe((/**
                 * @param {?} result
                 * @return {?}
                 */
                function (result) {
                    _this.keyManager.setActiveItem(-1);
                    _this.suggest = result;
                }));
            }
        }));
        this.search.searchOperationChanges.subscribe((/**
         * @param {?} state
         * @return {?}
         */
        function (state) {
            _this.searchOpRunning = _this.search.isActive();
        }));
    };
    /**
     * @return {?}
     */
    SearchboxComponent.prototype.onSearchFocus = /**
     * @return {?}
     */
    function () {
        if (this.suggest.length == 0 && this.keywords.length < 1) {
            this.showPopular = true;
        }
    };
    /**
     * @return {?}
     */
    SearchboxComponent.prototype.onSearchBlur = /**
     * @return {?}
     */
    function () {
        var _this = this;
        window.setTimeout((/**
         * @return {?}
         */
        function () {
            _this.showPopular = false;
            _this.suggest = [];
        }), 250);
    };
    /**
     * @return {?}
     */
    SearchboxComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.keyManager = new ActiveDescendantKeyManager(this.suggestResults);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    SearchboxComponent.prototype.onKeywordsChanged = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        switch (event.keyCode) {
            case ENTER:
                if (this.keyManager.activeItem) {
                    this.keyManager.activeItem.selectItem();
                }
                else {
                    this.cancelSuggest = true;
                }
                break;
            case UP_ARROW:
            case DOWN_ARROW:
            case TAB:
                this.keyManager.onKeydown(event);
                break;
            default:
                this.keywordsChanged$.next(((/** @type {?} */ (event.target))).value);
        }
    };
    /**
     * @param {?} suggestion
     * @return {?}
     */
    SearchboxComponent.prototype.selectSuggestion = /**
     * @param {?} suggestion
     * @return {?}
     */
    function (suggestion) {
        if (suggestion.type == "Provider") {
            this.search.reset();
            this.search.setQuery(suggestion.value);
            this.search.refresh();
        }
        else {
            this.search.reset();
            this.search.setKeywords(suggestion.value);
            this.search.toggleFacet(suggestion.suggestValue, suggestion.value);
            this.search.setLockFacet(suggestion.suggestValue, suggestion.value);
            this.search.refresh();
        }
        this.analytics.selectSuggestion(suggestion);
    };
    /**
     * @param {?} keywords
     * @param {?} $event
     * @return {?}
     */
    SearchboxComponent.prototype.searchSubmit = /**
     * @param {?} keywords
     * @param {?} $event
     * @return {?}
     */
    function (keywords, $event) {
        this.search.reset();
        this.search.setQuery(keywords);
        this.search.refresh();
        this.analytics.searchBoxSubmit(keywords);
        $event.preventDefault();
        return false;
    };
    /**
     * @return {?}
     */
    SearchboxComponent.prototype.resetSearch = /**
     * @return {?}
     */
    function () {
        this.search.resetSearch();
    };
    /**
     * @return {?}
     */
    SearchboxComponent.prototype.resetSearchVisible = /**
     * @return {?}
     */
    function () {
        return !this.searchOpRunning && (this.state && (this.state.query
            || Object.keys(this.state.facets).length > 0
            || this.state.distance
            || this.state.lat
            || this.state.lng));
    };
    SearchboxComponent.decorators = [
        { type: Component, args: [{
                    selector: 'wfbhsearch-searchbox',
                    template: "<form class=\"search-form\" (submit)=\"searchSubmit($event.target['search-keywords'].value, $event)\">\n    <div class=\"form-group form-group-lg \">\n        <label class=\"sr-only\" for=\"search-keywords\">Search Keywords</label>\n        <input autocomplete=\"off\" type=\"search\" class=\"form-control\" [(ngModel)]=\"keywords\" id=\"search-keywords\"\n            name=\"search-keywords\" (keyup)=\"onKeywordsChanged($event)\" (focus)=\"onSearchFocus()\" (blur)=\"onSearchBlur()\"\n            placeholder=\"Provider\u2019s name, specialty, condition, location...\">\n        <i id=\"search-running\" *ngIf=\"searchOpRunning\" class=\"fa fa-circle-o-notch fa-spin\"></i>\n        <a *ngIf=\"resetSearchVisible()\" class=\"reset-search\" title=\"Reset search\" aria-label=\"Reset search\"\n            (click)=\"resetSearch()\"><i class=\"fa fa-times\"></i> <span class=\"sr-only\">Reset search</span></a>\n    </div>\n\n    <button type=\"submit\" class=\"btn btn-default btn-provider-search\"><span class=\"desktop\">Search</span><span\n            class=\"mobile\"><i class=\"fa fa-search\"></i></span></button>\n    <div *ngIf=\"suggest.length || showPopular\" class=\"suggest-results\">\n        <ul role=\"listbox\" *ngIf=\"suggest.length\">\n            <li wfbhsearch-suggest-result *ngFor=\"let result of suggest\" [result]=\"result\"\n                (resultSelect)=\"selectSuggestion($event)\">\n            </li>\n        </ul>\n        <h3 class=\"popular-searches-title\" *ngIf=\"showPopular && !suggest.length\">Popular Searches</h3>\n        <ul role=\"listbox\" *ngIf=\"showPopular && !suggest.length\">\n            <li wfbhsearch-suggest-result *ngFor=\"let result of popularSearches\" [title]=\"result.title\"\n                [uri]=\"searchUrl + result.uri\" (resultSelect)=\"selectSuggestion($event)\">\n            </li>\n        </ul>\n    </div>\n</form>",
                    styles: [".search-help{font-size:12px;color:#333}@media all and (min-width:768px){.search-help{display:none}}.search-form{display:block;position:relative;width:100%;margin-bottom:0;padding-right:48px}.search-form .btn-provider-search{display:inline-block;position:absolute;right:0;top:0;width:auto;padding:9px 14px 8px}.search-form .btn-provider-search .desktop{display:none;font-size:1em}.search-form .btn-provider-search .mobile{display:inline-block;margin:0;font-size:1em}#search-keywords{width:100%;border-radius:0;margin-bottom:0;height:42px;font-size:16px;padding:10px 16px!important}.reset-search{position:absolute;right:52px;line-height:42px}@media all and (min-width:768px){.search-form{padding-right:143px}.search-form .btn-provider-search{padding:20px 40px}.search-form .btn-provider-search .desktop{display:inline}.search-form .btn-provider-search .mobile{display:none}#search-keywords{height:64px;font-size:18px}.reset-search{line-height:64px;right:153px;font-size:24px}}.suggest-results{width:100%;position:absolute;top:32px;left:0;padding:10px 0;margin:10px 0 0;border:1px solid #ccc;background:#fff;text-align:left;z-index:99;font-size:16px}.suggest-results ul{margin:0;padding:0}@media all and (min-width:768px){.suggest-results{top:64px;font-size:18px}}.popular-searches-title{font:12px/1.4 \"Avenir LT W01_35 Light1475496\",Arial,sans-serif;text-transform:uppercase;letter-spacing:1.95px;padding:0 14px;color:#333}.suggest-meta{font-family:\"Avenir LT W01_85 Heavy1475544\",Arial,sans-serif;font-size:60%}#search-running{font-size:14px;position:absolute;line-height:42px;right:55px}@media all and (min-width:768px){.popular-searches-title{padding:0 20px}#search-running{font-size:20px;position:absolute;line-height:64px;right:156px}}"]
                }] }
    ];
    /** @nocollapse */
    SearchboxComponent.ctorParameters = function () { return [
        { type: SearchService },
        { type: CoveoAnalyticsService }
    ]; };
    SearchboxComponent.propDecorators = {
        keywords: [{ type: Input }],
        useRouting: [{ type: Input }],
        searchUrl: [{ type: Input }],
        suggestResults: [{ type: ViewChildren, args: [SuggestResultComponent,] }]
    };
    return SearchboxComponent;
}());
if (false) {
    /** @type {?} */
    SearchboxComponent.prototype.keywords;
    /** @type {?} */
    SearchboxComponent.prototype.useRouting;
    /** @type {?} */
    SearchboxComponent.prototype.searchUrl;
    /** @type {?} */
    SearchboxComponent.prototype.suggestResults;
    /** @type {?} */
    SearchboxComponent.prototype.keywordsChanged$;
    /** @type {?} */
    SearchboxComponent.prototype.suggest;
    /** @type {?} */
    SearchboxComponent.prototype.cancelSuggest;
    /** @type {?} */
    SearchboxComponent.prototype.suggestLoading;
    /** @type {?} */
    SearchboxComponent.prototype.searchOpRunning;
    /** @type {?} */
    SearchboxComponent.prototype.state;
    /** @type {?} */
    SearchboxComponent.prototype.showPopular;
    /**
     * @type {?}
     * @private
     */
    SearchboxComponent.prototype.keyManager;
    /** @type {?} */
    SearchboxComponent.prototype.popularSearches;
    /** @type {?} */
    SearchboxComponent.prototype.search;
    /**
     * @type {?}
     * @private
     */
    SearchboxComponent.prototype.analytics;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SortComponent = /** @class */ (function () {
    function SortComponent(search, analytics) {
        this.search = search;
        this.analytics = analytics;
        this.sort = 'ascending';
    }
    /**
     * @return {?}
     */
    SortComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.search.searchStateChanged.subscribe((/**
         * @param {?} state
         * @return {?}
         */
        function (state) {
            _this.sort = state.sort;
            _this.state = state;
        }));
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    SortComponent.prototype.sortChange = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.search.setSort(this.sort);
        this.search.refresh();
        this.analytics.changeSortBy(this.sort);
    };
    SortComponent.decorators = [
        { type: Component, args: [{
                    selector: 'wfbhsearch-sort',
                    template: "<div *ngIf=\"search.totalResults > 0\" class=\"sort-widget\">\n    <label for=\"sort\">Sort by </label>\n    <select [(ngModel)]=\"sort\" class=\"form-control\" name=\"sort\" (change)=\"sortChange($event)\">\n        <option value=\"ascending\">A-Z</option>\n        <option value=\"descending\">Z-A</option>\n        <option *ngIf=\"state?.lat && state?.lng\" value=\"distance\">Distance</option>\n    </select>\n</div>",
                    styles: [".sort-widget{text-align:right}@media all and (max-width:1023px){.sort-widget{display:none}}.sort-widget label{display:inline-block;margin-right:4px;vertical-align:middle;font:bold 11px/36px \"Avenir LT W01_85 Heavy1475544\",Arial,sans-serif}.sort-widget .form-control[name=sort]{display:inline-block;width:114px;height:36px}select{-webkit-appearance:menulist;-moz-appearance:menulist}"]
                }] }
    ];
    /** @nocollapse */
    SortComponent.ctorParameters = function () { return [
        { type: SearchService },
        { type: CoveoAnalyticsService }
    ]; };
    return SortComponent;
}());
if (false) {
    /** @type {?} */
    SortComponent.prototype.sort;
    /** @type {?} */
    SortComponent.prototype.state;
    /** @type {?} */
    SortComponent.prototype.search;
    /**
     * @type {?}
     * @private
     */
    SortComponent.prototype.analytics;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function SchedulingServiceConfig() { }
if (false) {
    /** @type {?} */
    SchedulingServiceConfig.prototype.newPatientSchedulingUrl;
}
/** @type {?} */
var SCHEDULING_CONFIG = new InjectionToken('Scheduling service config');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SchedulingService = /** @class */ (function () {
    function SchedulingService(http, config) {
        this.http = http;
        this.config = config;
    }
    /**
     * @param {?} searchResult
     * @return {?}
     */
    SchedulingService.prototype.getExtPatientUrl = /**
     * @param {?} searchResult
     * @return {?}
     */
    function (searchResult) {
        return 'https://mywakehealth.org';
    };
    /**
     * @param {?} searchResult
     * @return {?}
     */
    SchedulingService.prototype.getNewPatientUrl = /**
     * @param {?} searchResult
     * @return {?}
     */
    function (searchResult) {
        return this.config.newPatientSchedulingUrl + "?id=" + searchResult.epicId + "&vt=1003";
    };
    /**
     * @param {?} searchResult
     * @return {?}
     */
    SchedulingService.prototype.getSchedulingMessage = /**
     * @param {?} searchResult
     * @return {?}
     */
    function (searchResult) {
        return this.http.get(searchResult.messagePath, { responseType: 'text' });
    };
    SchedulingService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    SchedulingService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: undefined, decorators: [{ type: Inject, args: [SCHEDULING_CONFIG,] }] }
    ]; };
    /** @nocollapse */ SchedulingService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SchedulingService_Factory() { return new SchedulingService(ɵɵinject(HttpClient), ɵɵinject(SCHEDULING_CONFIG)); }, token: SchedulingService, providedIn: "root" });
    return SchedulingService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    SchedulingService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    SchedulingService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var WfbhSearchModule = /** @class */ (function () {
    function WfbhSearchModule() {
    }
    /**
     * @param {?} searchConfig
     * @param {?} schedulingConfig
     * @return {?}
     */
    WfbhSearchModule.forRoot = /**
     * @param {?} searchConfig
     * @param {?} schedulingConfig
     * @return {?}
     */
    function (searchConfig, schedulingConfig) {
        return {
            ngModule: WfbhSearchModule,
            providers: [
                SearchService,
                {
                    provide: SEARCH_CONFIG,
                    useValue: searchConfig
                },
                SchedulingService,
                {
                    provide: SCHEDULING_CONFIG,
                    useValue: schedulingConfig
                }
            ]
        };
    };
    WfbhSearchModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        ActiveFacetComponent,
                        ActiveFacetsComponent,
                        FacetComponent,
                        FacetsComponent,
                        SearchInfoComponent,
                        SearchPageComponent,
                        SearchResultComponent,
                        SearchResultsComponent,
                        SearchboxComponent,
                        SortComponent,
                        SuggestResultComponent,
                    ],
                    imports: [
                        CommonModule,
                        HttpClientModule,
                        FormsModule,
                        GooglePlaceModule,
                        A11yModule,
                    ],
                    providers: [
                        Location$1,
                        { provide: LocationStrategy, useClass: PathLocationStrategy },
                        CookieService,
                    ],
                    exports: [
                        ActiveFacetComponent,
                        ActiveFacetsComponent,
                        FacetComponent,
                        FacetsComponent,
                        SearchInfoComponent,
                        SearchPageComponent,
                        SearchResultComponent,
                        SearchResultsComponent,
                        SearchboxComponent,
                        SortComponent
                    ]
                },] }
    ];
    return WfbhSearchModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ActiveFacetComponent, ActiveFacetsComponent, CoveoAnalyticsService, CoveoFieldSuggestionBatchResult, CoveoFieldSuggestionResult, CoveoGroupByResult, CoveoResult, CoveoResultRaw, CoveoSearchResponse, DialogService, Facet, FacetComponent, FacetOption, FacetOptionValue, FacetsComponent, Location, SEARCH_CONFIG, SearchInfoComponent, SearchNavigatorService, SearchNavigatorSpaService, SearchOperationsStatus, SearchOperationsStatusState, SearchPageComponent, SearchResult, SearchResultComponent, SearchResults, SearchResultsComponent, SearchService, SearchState, SearchboxComponent, SortComponent, SuggestResultComponent, Suggestion, WfbhSearchModule, ActiveFacetComponent as ɵa, ActiveFacetsComponent as ɵb, FacetComponent as ɵc, FacetsComponent as ɵd, SearchInfoComponent as ɵe, SearchPageComponent as ɵf, SearchResultComponent as ɵg, SearchResultsComponent as ɵh, SearchboxComponent as ɵi, SuggestResultComponent as ɵj, SortComponent as ɵk, SchedulingService as ɵl, SCHEDULING_CONFIG as ɵn };
//# sourceMappingURL=wfbhsearch.js.map
